/**
 * chem-equilibrium - equilibrium - ...
 * @version v1.1.1
 * @link https://github.com/cheminfo-js/equilibrium
 * @license MIT
 */
!function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Equilibrium=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';
var Matrix = require('ml-matrix');
var mersenneTwister = require('mersenne-twister');

//species are all dissolved substances in the equilibrium
//components are substances whose concentrations are independent variables determining all species concentrations
//as many formation reactions as species must be provided
//for each component, either total concentration or equilibrium concentration (to be kept fixed) must be provided. Solvent is an exception (see below)
//canonical ordering of input is key: precipitation reactions must be given last, coefficients of substances with fixed equilibrium concentrations come last
//columns of the coefficients matrix must match the elements of the equilibriumComponentConcentartions vector
//rows of the coefficients matrix must match elements of the constants vector
//first elements of constants vector must match elements of equilibriumComponentConcentrations vector
//first elements of equilibriumComponentConcentrations vector must match elements of totalComponentConcentrations vector
// the last component is a special component: the solvent. It does not have an associated mass balance equation and its activity is either set to 1
// (in which case it is a fixed activity component) or computed using Raoult's law


function EquilibriumCalculator(options) {
    // Model parameters:
    // solutionSpeciesConstants
    // solutionSpeciesCoefficients
    // solutionSpeciesCharges
    // solidSpeciesConstants
    // solidSpeciesCoefficients

    // Independent variables
    // fixedTotalComponentConcentrations
    // componentActivities
    // ionicStrength

    // Input constraints
    // totalConcentrations.length + fixedConcentrations.length must equal the number of columns in coefficients

    var concScaling, i, j;
    if(options instanceof EquilibriumCalculator) {
        var eq = options;
        this.rnd = eq.rnd;
        this.maxGuesses = eq.maxGuesses;
        this.solutionSpeciesConstants = eq.getSolutionEquilibriumConstants();
        this.solutionSpeciesCoefficients = eq.getSolutionSpeciesCoefficients();
        this.solutionSpeciesCharges = eq.getSolutionSpeciesCharges();
        this.solidSpeciesConstants = eq.getSolidEquilibriumConstants();
        this.solidSpeciesCoefficients = eq.getSolidSpeciesCoefficients();
        this.fixedTotalComponentConcentrations = eq.getFixedTotalConcentrations();
        this.componentActivities = eq.getComponentActivities();
        this.ionicStrength = eq.getIonicStrength();

        this.solidSpeciesConcentrations = eq.getSolidsConcentrations();

        this.solutionSpeciesConcentrations = eq.getSolutionSpeciesConcentrations();

        this.nSolids = eq.getNumberOfSolids();
        this.nSolutionSpecies = eq.getNumberOfSolutionSpecies();
        this.nComponents = eq.getNumberOfComponents();
        this.nFixedTotalConcentrations = eq.getNumberOfUnfixedComponents();

        this.concentrationScaling = initialize1DArray(this.nFixedTotalConcentrations);

        for (i = 0; i < this.nFixedTotalConcentrations; i++) {
            this.concentrationScaling[i] = 1.0;
            for (j = 0; j < this.nSolutionSpecies; j++) {
                if (this.solutionSpeciesCoefficients[j][i] != 0.0) {
                    concScaling = 1.0 / Math.pow(this.solutionSpeciesConstants[j], 1.0 / this.solutionSpeciesCoefficients[j][i]);
                    if (concScaling < this.concentrationScaling[i]) {
                        this.concentrationScaling[i] = concScaling;
                    }
                }
            }
            for (j = 0; j < this.nSolids; j++)
            if (this.solidSpeciesCoefficients[j][i] != 0.0) {
                concScaling = Math.pow(this.solidSpeciesConstants[j], 1.0 / this.solidSpeciesCoefficients[j][i]);
                if (concScaling < this.concentrationScaling[i])
                    this.concentrationScaling[i] = concScaling;
            }
        }
    }
    else {
        //initiate equilibrium constants, coefficients, total concentrations, and number of solids/precipitation rxns from input
        optionsAsProperties(this, options);
        if(!this.maxGuesses) this.maxGuesses = 1000;
        if(typeof options.randomGenerator === 'function') {
            this.rnd = options.randomGenerator
        }
        else if(Array.isArray(options.randomGenerator)) {
            if(options.randomGenerator[0] === 'default') {
                this.rnd = Math.random;
            }
            else if(options.randomGenerator[0] === 'seed') {
                this.rnd = rndWithSeed(options.randomGenerator[1] || 0);
            }
            else if(options.randomGenerator[0] === 'constant')
                this.rnd = constantRandom(options.randomGenerator[1] || 0.5)
        }
        else {
            if(options.randomGenerator === 'default')
                this.rnd = Math.random;
            else if(options.randomGenerator === 'seed')
                this.rnd = rndWithSeed(0);
            else if(options.randomGenerator === 'constant') {
                this.rnd = constantRandom(0.5);
            }
        }

        if(this.rnd === undefined && options.randomGenerator !== undefined) {
            console.warn('Unknown randomGenerator option, falling back to default random generator');
            this.rnd = Math.random;
        }
        else if(this.rnd === undefined) {
            this.rnd = Math.random;
        }


        this.nSolutionSpecies = this.solutionCoefficients.length;
        this.nComponents = this.solutionCoefficients[0].length;
        this.nSolids = this.precipitationConstants.length;
        this.nFixedTotalConcentrations = this.totalConcentrations.length;

        this.componentActivities = initialize1DArray(this.nComponents);
        this.solutionSpeciesConstants = this.solutionConstants;
        this.solutionSpeciesCharges = this.solutionSpeciesCharges;
        this.solutionSpeciesCoefficients = this.solutionCoefficients;
        this.solidSpeciesConstants = this.precipitationConstants;
        this.solidSpeciesCoefficients = this.precipitationCoefficients;
        this.fixedTotalComponentConcentrations = this.totalConcentrations;
        this.solidSpeciesConcentrations = initialize1DArray(this.nSolids);
        this.solutionSpeciesConcentrations = initialize1DArray(this.nSolutionSpecies);
        this.ionicStrength = 0;

        // Initiate all solids to zero
        for (i = 0; i < this.nSolids; i++) {
            this.solidSpeciesConcentrations[i] = 0.0;
        }

        this.concentrationScaling = initialize1DArray(this.nFixedTotalConcentrations);

        // compute the concentration scaling factors
        for (i = 0; i < this.nFixedTotalConcentrations; i++) {
            this.concentrationScaling[i] = 1.0;
            for (j = 0; j < this.nSolutionSpecies; j++) {
                if (this.solutionSpeciesCoefficients[j][i] != 0.0) {
                    concScaling = 1.0 / Math.pow(this.solutionSpeciesConstants[j], 1.0 / this.solutionSpeciesCoefficients[j][i]);
                    if (concScaling < this.concentrationScaling[i]) {
                        this.concentrationScaling[i] = concScaling;
                    }
                }
            }
            for (j = 0; j < this.nSolids; j++) {
                if (this.solidSpeciesCoefficients[j][i] != 0.0) {
                    concScaling = Math.pow(this.solidSpeciesConstants[j], 1.0 / this.solidSpeciesCoefficients[j][i]);
                    if (concScaling < this.concentrationScaling[i]) {
                        this.concentrationScaling[i] = concScaling;
                    }
                }
            }
        }

        //store fixed component activities at the end of the array of component activities (leave last for solvent)
        for (i = this.nFixedTotalConcentrations; i < this.nComponents - 1; i++) {
            this.componentActivities[i] = this.fixedActivities[(i - this.nFixedTotalConcentrations)];
        }
        //initial guess of variable component activities, solvent activity and ionic strength
        guess(this, true, false);
    }
}

// equilibrium concentrations of all soluble species and amount of each solid precipitated per litter of solution.
// solvent is an exception: it's activity is returned instead
EquilibriumCalculator.prototype.getComponentActivities = function() {
    return this.componentActivities.slice(0, this.nComponents);
};

EquilibriumCalculator.prototype.finalConcentrations = function() {
    var result = this.solutionSpeciesConcentrations.slice(0, this.nSolutionSpecies + this.nSolids);
    for (var i = 0; i < this.nSolids; i++) {
        result[(this.nSolutionSpecies + i)] = this.solidSpeciesConcentrations[i];
    }
    result[this.nComponents - 1] = this.componentActivities[this.nComponents - 1];
    return result;
};

EquilibriumCalculator.prototype.getSolutionSpeciesCoefficients = function() {
    return deepCopy(this.solutionSpeciesCoefficients, this.nSolutionSpecies, this.nComponents);
};



EquilibriumCalculator.prototype.getIonicStrength = function() {
    return this.ionicStrength;
};

//Return fixed total component concentrations
EquilibriumCalculator.prototype.getFixedTotalConcentrations = function() {
    return this.fixedTotalComponentConcentrations.slice(0, this.nFixedTotalConcentrations);
};

EquilibriumCalculator.prototype.getSolutionEquilibriumConstants = function() {
    return this.solutionSpeciesConstants.slice(0, this.nSolutionSpecies);
};

EquilibriumCalculator.prototype.getSolidEquilibriumConstants = function() {
    return this.solidSpeciesConstants.slice(0 , this.nSolids);
};

EquilibriumCalculator.prototype.getSolutionSpeciesCharges = function() {
    return this.solutionSpeciesCharges.slice(0, this.nSolutionSpecies);
};

EquilibriumCalculator.prototype.getSolidSpeciesCoefficients = function() {
    return deepCopy(this.solidSpeciesCoefficients, this.nSolids, this.nComponents);
};

EquilibriumCalculator.prototype.getSolidsConcentrations = function() {
    return this.solidSpeciesConcentrations.slice(0, this.nSolids);
};

EquilibriumCalculator.prototype.getSolutionSpeciesConcentrations = function() {
    return this.solutionSpeciesConcentrations.slice(0, this.nSolutionSpecies);
};

EquilibriumCalculator.prototype.getNumberOfSolutionSpecies = function() {
    return this.nSolutionSpecies;
};

EquilibriumCalculator.prototype.getNumberOfSolids = function() {
    return this.nSolids;
};

EquilibriumCalculator.prototype.getNumberOfSpecies = function() {
    return this.nSolids + this.nSolutionSpecies;
};

EquilibriumCalculator.prototype.getNumberOfComponents = function() {
    return this.nComponents;
};

EquilibriumCalculator.prototype.getNumberOfUnfixedComponents = function() {
    return this.nFixedTotalConcentrations;
};

EquilibriumCalculator.prototype.solutionSpeciesActivities = function()
{
    var result = initialize1DArray(this.nSolutionSpecies);
    //initialize non-component species activities to their formation constant
    var i, j;
    for (i = this.nComponents; i < this.nSolutionSpecies; i++) {
        result[i] = this.solutionSpeciesConstants[i];
    }
    for (i = 0; i < this.nComponents; i++) { //component activities are read directly from componentActivities array
        result[i] = this.componentActivities[i];
        for (j = this.nComponents; j < this.nSolutionSpecies; j++) { //non-component species activities are calculated from equilibrium constant expressions
            result[j] *= Math.pow(this.componentActivities[i], this.solutionSpeciesCoefficients[j][i]);
        }
    }
    return result;
};
//activity coefficients are computed using Davies' equation with A=0.5085 M^-1/2 (valid for water at 25°C)
//note that activity coefficient of solvent has no meaning
EquilibriumCalculator.prototype.solutionSpeciesActivityCoefficients = function()
{
    var result = initialize1DArray(this.nSolutionSpecies);
    var exponentialCoefficient = Math.sqrt(this.ionicStrength);
    exponentialCoefficient = (exponentialCoefficient / (1.0 + exponentialCoefficient) - 0.3 * this.ionicStrength) * -0.5085;
    for (var i = 0; i < this.nSolutionSpecies; i++) {
        result[i] = Math.exp(exponentialCoefficient * Math.pow(this.solutionSpeciesCharges[i], 2.0));
    }
    return result;
};

// note that species concentration value of solvent cannot be computed by this method, but we don't really care about it pretty much by definition.
// It is set to 0 to make sure that it is not mistakenly used in any balance
EquilibriumCalculator.prototype.calculateSolutionSpeciesConcentrations = function(correctActivities) {
    this.solutionSpeciesConcentrations = this.solutionSpeciesActivities();
    if (correctActivities) {
        var activityCoefficients = this.solutionSpeciesActivityCoefficients();
        for (var i = 0; i < this.nSolutionSpecies; i++) {
            this.solutionSpeciesConcentrations[i] /= activityCoefficients[i];
        }
        this.solutionSpeciesConcentrations[(this.nComponents - 1)] = 0.0;
    }
};

//computes the solubility products of all solid species
EquilibriumCalculator.prototype.solubilityProducts = function() {
    var result = initialize1DArray(this.nSolids);
    for (var i = 0; i < this.nSolids; i++) {
        result[i] = 1.0;
        for (var j = 0; j < this.nComponents; j++) {
            result[i] *= Math.pow(this.componentActivities[j], this.solidSpeciesCoefficients[i][j]);
        }
    }
    return result;
};

//computes the ratios between each solid's solubility product and the corresponding solubility constant
EquilibriumCalculator.prototype.saturationIndices = function()
{
    var  result = this.solubilityProducts();
    for (var i = 0; i < this.nSolids; i++) {
        result[i] /= this.solidSpeciesConstants[i];
    }
    return result;
};

//Total concentrations of ALL components but the solvent
//Computed from current activities, not read from fixedTotalComponentConcentrations
EquilibriumCalculator.prototype.totalConcentrations = function()
{
    return product(this.solutionSpeciesConcentrations, this.solutionSpeciesCoefficients, this.nSolutionSpecies, this.nComponents - 1);
};

//sets equilibrium concentration of a component
// WARNING: does not fix the given equilibrium concentration, after assignment the system iterates to equilibrium and will change the
// assigned component concentration unless it was already fixed at construction
EquilibriumCalculator.prototype.setEquilibriumActivity = function(component, value) {
    this.componentActivities[component] = value;
};

//sets the amount of a solid precipitated per litter of solution
EquilibriumCalculator.prototype.setPrecipitateConcentration = function(solid, value) {
    this.solidSpeciesConcentrations[solid] = value;
};

//set the total concentration of a component. Only allowed on components with total concentration fixed at construction
EquilibriumCalculator.prototype.setTotalConcentration = function(component, value)
{
    this.fixedTotalComponentConcentrations[component] = value;
    if (value == 0.0)
    this.componentActivities[component] = 0.0;
};

//sets the value of an equilibrium constant. Concentration scaling factors for equilibrium concentration guesses are updated after assignment.
EquilibriumCalculator.prototype.setSolutionEquilibriumConstant = function(constant, value) {
    this.solutionSpeciesConstants[constant] = value;
    var concScaling;
    for (var i = 0; i < this.nFixedTotalConcentrations; i++) {
        if (this.solutionSpeciesCoefficients[constant][i] != 0.0) {
            concScaling = 1.0 / Math.pow(value, 1.0 / this.solutionSpeciesCoefficients[constant][i]);
            if (concScaling < this.concentrationScaling[i])
                this.concentrationScaling[i] = concScaling;
        }
    }
};

//sets the value of an equilibrium constant. Concentration scaling factors for equilibrium concentration guesses are updated after assignment.
EquilibriumCalculator.prototype.setSolidEquilibriumConstant = function(constant, value)
{
    this.solidSpeciesConstants[constant] = value;
    var concScaling;
    for (var i = 0; i < this.nFixedTotalConcentrations; i++) {
        if (this.solidSpeciesCoefficients[constant][i] != 0.0) {
            concScaling = 1.0 / Math.pow(value, 1.0 / this.solidSpeciesCoefficients[constant][i]);
            if (concScaling < this.concentrationScaling[i])
                this.concentrationScaling[i] = concScaling;
        }
    }
};

EquilibriumCalculator.prototype.setIonicStrength = function(ionicStrength) {
    this.ionicStrength = ionicStrength;
};


EquilibriumCalculator.prototype.calculatedIonicStrength = function() {
    var result = 0.0;
    for (var i = 0; i < this.nSolutionSpecies; i++) {
        result += Math.pow(this.solutionSpeciesCharges[i], 2.0) * this.solutionSpeciesConcentrations[i];
    }
    return result / 2.0;
};

//shifts all solid species towards solution
//NOTE: what am i using this for?
EquilibriumCalculator.prototype.disolveAll = function(correctActivities) {
    for (var j = 0; j < this.nSolids; j++)
    disolve(this, j, correctActivities);
};

//remove the species itself
EquilibriumCalculator.prototype.removeSolutionSpecies = function(species) {
    this.nSolutionSpecies -= 1;
    var i,j;
    //if species is a component, remove all its derived species and remove it from components and coefficients arrays
    for (i = species; i < this.nSolutionSpecies; i++) {
        this.solutionSpeciesCharges[i] = this.solutionSpeciesCharges[(i + 1)];
        this.solutionSpeciesConcentrations[i] = this.solutionSpeciesConcentrations[(i + 1)];
        this.solutionSpeciesConstants[i] = this.solutionSpeciesConstants[(i + 1)];
        this.solutionSpeciesCoefficients[i] = this.solutionSpeciesCoefficients[(i + 1)];
    }

    if (species < this.nComponents) {
        //remove derived solution species
        for (i = 0; i < this.nSolutionSpecies; i++) {
            if (this.solutionSpeciesCoefficients[i][species] != 0.0) {
                this.removeSolutionSpecies(i);
                i--;
            }
            else {
                //remove from coefficients of solution reactions
                for (j = species; j < this.nComponents - 1; j++) {
                    this.solutionSpeciesCoefficients[i][j] = this.solutionSpeciesCoefficients[i][j + 1];
                }
            }
        }
        //remove derived solid species
        for (i = 0; i < this.nSolids; i++) {
            if (this.solidSpeciesCoefficients[i][species] != 0.0) {
                this.removeSolid(i);
                i--;
            }
            else { //remove from coefficients of solid reactions
                for (j = species; j < this.nComponents - 1; j++) {
                    this.solidSpeciesCoefficients[i][j] = this.solidSpeciesCoefficients[i][(j + 1)];
                }
            }
        }

        //remove the component itself
        this.nComponents -= 1;
        if (species < this.nFixedTotalConcentrations) {
            //if species is an unfixed component (unfixed activity) remove it from total concentration array as well
            this.nFixedTotalConcentrations -= 1;
            for (i = species; i < this.nFixedTotalConcentrations; i++) {
                this.fixedTotalComponentConcentrations[i] = this.fixedTotalComponentConcentrations[i + 1];
                this.componentActivities[i] = this.componentActivities[i + 1];
            }
            for (i = this.nFixedTotalConcentrations; i < this.nComponents; i++)
                this.componentActivities[i] = this.componentActivities[(i + 1)];
        }
        else
        {
            for (i = species; i < this.nComponents; i++)
                this.componentActivities[i] = this.componentActivities[(i + 1)];
        }
    }
};

EquilibriumCalculator.prototype.removeSolid = function(solid) {
    this.nSolids -= 1;
    if (this.nSolids > 0) {
        for (var i = solid; i < this.nSolids; i++) {
            this.solidSpeciesConcentrations[i] = this.solidSpeciesConcentrations[(i + 1)];
            this.solidSpeciesConstants[i] = this.solidSpeciesConstants[(i + 1)];
            this.solidSpeciesCoefficients[i] = this.solidSpeciesCoefficients[(i + 1)];
        }
    }
    else {
        this.solidSpeciesCoefficients = [[]];
        this.solidSpeciesConcentrations = [];
        this.solidSpeciesConstants = [];
    }
};

EquilibriumCalculator.prototype.addSolutionSpecies = function(){
};

EquilibriumCalculator.prototype.addSolid = function() {
};

EquilibriumCalculator.prototype.addComponent = function() {
};

//returns the equilibriumCalculator object comprising only components with non-zero total concentrations and their derived species
EquilibriumCalculator.prototype.removeZeroConcentrations = function()
{
    var result = new EquilibriumCalculator(this);
    for (var i = 0; i < result.nFixedTotalConcentrations; i++) {
        if (result.fixedTotalComponentConcentrations[i] == 0.0) {
            result.removeSolutionSpecies(i);
            i--;
        }
    }
    return result;
};

EquilibriumCalculator.prototype.calculate = function(correctActivities, fixedIonicStrength, maxIterations, precision, maxGuesses) {
    if(arguments.length === 2) {
        return this.calculate(correctActivities, fixedIonicStrength, 99999, this.maxGuesses, 0.0001);
    }
    else if(arguments.length === 4) {
        return this.calculate(correctActivities, fixedIonicStrength, maxIterations, this.maxGuesses, precision);
    }
    else if(arguments.length === 5) {
        var tmp; tmp = maxGuesses;
        maxGuesses = precision;
        precision = tmp;

        var nGuesses = 0, i, result;
        if (!correctActivities) {
            this.componentActivities[(this.nComponents - 1)] = 1.0;
        }
        while (nGuesses < maxGuesses) {
            try {
                nGuesses++;
                result = calculateOnePoint(this, correctActivities, fixedIonicStrength, maxIterations, precision);
                if (result == maxIterations) {
                    //console.log("maximum number of iterations reached, result is not trustworthy");
                }
                //console.log("Solution found will now be checked");
                while ((hasNegative(this.finalConcentrations(), this.nSolutionSpecies + this.nSolids)) && (nGuesses < maxGuesses)) {
                    nGuesses++;
                    //console.log("Inadequate solution (negative, infinite, or not a number), computing with the " + nGuesses + "th  guess");

                    guess(this, correctActivities, fixedIonicStrength);
                    result = calculateOnePoint(this, correctActivities, fixedIonicStrength, maxIterations, precision);
                    if (result == maxIterations) {
                        //console.log("maximum number of iterations reached, result is not trustworthy");
                    }
                    //console.log("Solution found will now be checked");
                }
                if (hasNegative(this.finalConcentrations(), this.nSolutionSpecies + this.nSolids)) {
                    return "No successful guess";
                }
                if (result < maxIterations) {
                    return "Adequate solution";
                }
                return "Last guess failed to converge, results might not be valid!";
            } catch (e) {
                if (nGuesses < maxGuesses) {
                    console.log(e.stack);
                    console.log("Error occurred during calculation (" + e + "), retrying with the " + (nGuesses + 1) + "th guess");
                    for (i = 0; i < this.nSolids; i++) {
                        this.solidSpeciesConcentrations[i] = 0.0;
                    }
                    guess(this, correctActivities, fixedIonicStrength);
                }

            }

        }

        console.log("Error");
        return "Error";
    }
};



// Private =======================================================

//shifts the whole precipitated mass of a solid species towards solution
//all dissolved solid is put in the form of its components. Naturally, leaves solution unbalanced
//the corresponding activities are corrected using the current ionic strength, ionic strength is not corrected for the increased solution species concentrations.
//WARNING: consequences of using on an unbalanced solution are unknown. Privatized just in case.
function disolve(ctx, solid, correctActivities) {
    for (var i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        ctx.solutionSpeciesConcentrations[i] +=
            ctx.solidSpeciesConcentrations[solid] * ctx.solidSpeciesCoefficients[solid][i];
        ctx.componentActivities[i] = ctx.solutionSpeciesConcentrations[i];
    }
    ctx.solidSpeciesConcentrations[solid] = 0.0;
    if (correctActivities) {
        var activityCoefficients = ctx.solutionSpeciesActivityCoefficients();
        for (i = 0; i < ctx.nFixedTotalConcentrations; i++)
            ctx.componentActivities[i] /= activityCoefficients[i];
    }
}

//computes solvent activity using an approximation based on raoult's law (same used by phreeqc)
function calculatedSolventActivity(ctx) {
    var result = 0.0;
    for(var i=0; i<ctx.solutionSpeciesConcentrations.length ; i++) {
        result += ctx.solutionSpeciesConcentrations[i];
    }
    return 1.0 - 0.017 * result;
}

//randomly guess equilibrium activities for the system's components and updates species concentrations, ionic strength, and solvent activity
function guess(ctx, correctActivities, fixedIonicStrength)
{
    var factor = ctx.rnd();
    //console.log('factor', factor);
    var i;
    //guess variable component activities
    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
    ctx.componentActivities[i] = (ctx.fixedTotalComponentConcentrations[i] * Math.pow(ctx.concentrationScaling[i], factor));
}
    //guess ionic strength as that computed from species concentrations computed assuming ionic strength = zero and solvent activity = 1
    //guess solvent activity as that computed from species concentrations computed assuming ionic strength = zero and solvent activity = 1
    ctx.componentActivities[(ctx.nComponents - 1)] = 1.0;
    if (correctActivities) {
        if (!fixedIonicStrength) {
            ctx.ionicStrength = 0.0;
        }
        ctx.calculateSolutionSpeciesConcentrations(correctActivities);
        if (!fixedIonicStrength) {
            ctx.ionicStrength = ctx.calculatedIonicStrength();
        }
        ctx.componentActivities[(ctx.nComponents - 1)] = calculatedSolventActivity(ctx);
    }

    for (i = 0; i < ctx.nSolids; i++)
    ctx.solidSpeciesConcentrations[i] = 0.0;
}

// balance for solution components, given solid species, and ionic strength if desired
// balance equations for solution components with unfixed activities but fixed total concentrations is the difference between
// the fixed total concentration and the total concentration computed from the current equilibrium concentrations
// balance equation for ionic strength is the difference between the current ionic strength and that computed from current species concentrations
// balance equation for solids is the difference between the solubility constant and the current solubility product
function balance(ctx, correctActivities, fixedIonicStrength, solids) {
    //sub-optimal code for the sake of readability
    var solidsLength = solids.length;
    var balanceError = [];
    // initialization and activity correction-contingent balances
    if (correctActivities)
    {
        if (fixedIonicStrength) {
            balanceError = initialize1DArray(ctx.nFixedTotalConcentrations + solidsLength + 1);
        }
        else {
            balanceError = initialize1DArray(ctx.nFixedTotalConcentrations + solidsLength + 2);
            //balance of ionic strength
            balanceError[(ctx.nFixedTotalConcentrations + solidsLength + 1)] = (ctx.ionicStrength - ctx.calculatedIonicStrength());
        }
        //balance of solvent activity
        balanceError[(ctx.nFixedTotalConcentrations + solidsLength)] = (ctx.componentActivities[(ctx.nComponents - 1)] - calculatedSolventActivity(ctx));
    }
    else {
        balanceError = initialize1DArray(ctx.nFixedTotalConcentrations + solidsLength);
    }
    //balance of solution components
    //substract solution species
    balanceError = sum(balanceError, minus(ctx.fixedTotalComponentConcentrations,
        product(ctx.solutionSpeciesConcentrations, ctx.solutionSpeciesCoefficients, ctx.nSolutionSpecies, ctx.nFixedTotalConcentrations),
        ctx.nFixedTotalConcentrations), ctx.nFixedTotalConcentrations, true);

    //substract solid species
    if (ctx.nSolids > 0) {
        balanceError = minus(balanceError,
            product(ctx.solidSpeciesConcentrations, ctx.solidSpeciesCoefficients, ctx.nSolids, ctx.nFixedTotalConcentrations),
            ctx.nFixedTotalConcentrations, true);
    }

    //balance of solids
    var solubilityProducts = ctx.solubilityProducts();
    var solidIndex = ctx.nFixedTotalConcentrations;
    for (var i=0; i<solids.length; i++) {
        balanceError[solidIndex] = (ctx.solidSpeciesConstants[solids[i]] - solubilityProducts[solids[i]]);
        solidIndex++;
    }

    return balanceError;
}

function componentComponentDerivatives(ctx) {
    var i, j,k;
    var result = initialize2DArray(ctx.nFixedTotalConcentrations, ctx.nFixedTotalConcentrations);
    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        for (j = 0; j < ctx.nFixedTotalConcentrations; j++) {
            result[i][j] = 0.0;
            for (k = 0; k < ctx.nSolutionSpecies; k++) {
                result[i][j] += ctx.solutionSpeciesCoefficients[k][j] * ctx.solutionSpeciesCoefficients[k][i] * ctx.solutionSpeciesConcentrations[k];
            }
            result[i][j] /= ctx.componentActivities[i];
        }
    }
    return result;
}

function componentIonicStrengthDerivatives(ctx) {
    var result = initialize1DArray(ctx.nFixedTotalConcentrations);
    var i, j;
    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        result[i] = 0.0;
        for (j = 0; j < ctx.nSolutionSpecies; j++) {
            result[i] +=
                ctx.solutionSpeciesCharges[j] * ctx.solutionSpeciesCharges[j] * ctx.solutionSpeciesCoefficients[j][i] *
                ctx.solutionSpeciesConcentrations[j];
        }
        result[i] = (result[i] * 0.5085 * (1.0 / (2.0 * Math.sqrt(ctx.ionicStrength) * Math.pow(1.0 + Math.sqrt(ctx.ionicStrength), 2.0)) - 0.3));
    }
    return result;
}

function componentSolidDerivatives(ctx, solids) {
    var result = initialize2DArray(solids.length, ctx.nFixedTotalConcentrations);
    var solidIndex = 0;
    for (var j=0; j<solids.length; j++) {
        for (var i = 0; i < ctx.nFixedTotalConcentrations; i++) {
            result[solidIndex][i] = ctx.solidSpeciesCoefficients[solids[j]][i];
        }
        solidIndex++;
    }
    return result;
}

function componentSolventDerivatives(ctx) {
    var result = initialize1DArray(ctx.nFixedTotalConcentrations);
    var solventActivity = ctx.componentActivities[(ctx.nComponents - 1)];
    for (var i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        for (var j = 0; j < ctx.nSolutionSpecies; j++) {
            result[i] +=
                ctx.solutionSpeciesCoefficients[j][i] * ctx.solutionSpeciesCoefficients[j][(ctx.nComponents - 1)] * ctx.solutionSpeciesConcentrations[j];
        }
        result[i] /= solventActivity;
    }
    return result;
}

function solidComponentDerivatives(ctx, solids) {
    var result = initialize2DArray(ctx.nFixedTotalConcentrations, solids.length);
    var solubilityProducts = ctx.solubilityProducts();
    var solidIndex = 0;
    for (var j=0; j<solids.length; j++) {
        for (var i = 0; i < ctx.nFixedTotalConcentrations; i++) {
            result[i][solidIndex] = (solubilityProducts[solids[j]] * ctx.solidSpeciesCoefficients[solids[j]][i] / ctx.componentActivities[i]);
        }
        solidIndex++;
    }
    return result;
}

function solidSolventDerivatives(ctx, solids) {
    var result = initialize1DArray(solids.length);
    var solubilityProducts = ctx.solubilityProducts();
    var solventActivity = ctx.componentActivities[(ctx.nComponents - 1)];
    var solidIndex = 0;
    for (var j=0; j<solids.length; j++) {
        result[solidIndex] = (ctx.solidSpeciesCoefficients[solids[j]][(ctx.nComponents - 1)] * solubilityProducts[solids[j]] / solventActivity);
        solidIndex++;
    }
    return result;
}

function ionicStrengthComponentDerivatives(ctx) {
    var result = initialize1DArray(ctx.nFixedTotalConcentrations);
    var i,j;
    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        result[i] = 0.0;
        for (j = 0; j < ctx.nSolutionSpecies; j++) {
            result[i] +=
                ctx.solutionSpeciesCharges[j] * ctx.solutionSpeciesCharges[j] * ctx.solutionSpeciesCoefficients[j][i] *
                ctx.solutionSpeciesConcentrations[j];
        }
        result[i] /= 2.0 * ctx.componentActivities[i];
    }
    return result;
}

function ionicStrengthIonicStrengthDerivative(ctx) {
    var result = 0.0;
    var i;
    for (i = 0; i < ctx.nSolutionSpecies; i++) {
        result += Math.pow(ctx.solutionSpeciesCharges[i], 4.0) * ctx.solutionSpeciesConcentrations[i];
    }
    result = result * 0.25425 * (1.0 / (2.0 * Math.sqrt(ctx.ionicStrength) * Math.pow(1.0 + Math.sqrt(ctx.ionicStrength), 2.0)) - 0.3) - 1.0;
    return result;
}

function ionicStrengthSolventDerivative(ctx) {
    var result = 0.0;
    var i;
    for (i = 0; i < ctx.nSolutionSpecies; i++) {
        result += Math.pow(ctx.solutionSpeciesCharges[i], 2.0) * ctx.solutionSpeciesCoefficients[i][(ctx.nComponents - 1)] * ctx.solutionSpeciesConcentrations[i];
    }
    return result / (ctx.componentActivities[(ctx.nComponents - 1)] * 2.0);
}

function solventComponentsDerivatives(ctx) {
    var result = initialize1DArray(ctx.nFixedTotalConcentrations);
    var i,j;
    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        for (j = 0; j < ctx.nSolutionSpecies; j++) {
            result[i] += ctx.solutionSpeciesCoefficients[j][i] * ctx.solutionSpeciesConcentrations[j];
        }
        result[i] = (result[i] * 0.017 / ctx.componentActivities[i]);
    }
    return result;
}

function solventIonicStrengthDerivative(ctx) {
    var result = 0.0;
    var i;
    for (i = 0; i < ctx.nSolutionSpecies; i++) {
        result += Math.pow(ctx.solutionSpeciesCharges[i], 2.0) * ctx.solutionSpeciesConcentrations[i];
    }
    return result * -0.017 * 0.5085 * (1.0 / (2.0 * Math.sqrt(ctx.ionicStrength) * Math.pow(1.0 + Math.sqrt(ctx.ionicStrength), 2.0)) - 0.3);
}

function solventSolventDerivative(ctx) {
    var result = 0.0;
    for (var i = 0; i < ctx.nSolutionSpecies; i++) {
        result += ctx.solutionSpeciesConcentrations[i];
    }
    return -1.0 - result * 0.017;
}

// Jacobian of balance
// actually it returns jacobian * -1
function balanceJacobian(ctx, correctActivities, fixedIonicStrength, solids) {
    //derivatives are calculated using the adequate methods (or trivially if that is the case) and then copied in the adequate blocks of the jacobian
    var componentComponent = componentComponentDerivatives(ctx);
    var componentSolid = componentSolidDerivatives(ctx, solids);
    var solidComponent = solidComponentDerivatives(ctx, solids);
    var solidsLength = solids.length;
    var jacobian = [[]];
    var i, j;

    //reserve the correct amount of space for the jacobian and compute activity correction-contingent elements
    if (correctActivities)
    {
        if (fixedIonicStrength) {
            jacobian = initialize2DArray(ctx.nFixedTotalConcentrations + solidsLength + 1,ctx.nFixedTotalConcentrations + solidsLength + 1);
        }
        else {
            jacobian = initialize2DArray(ctx.nFixedTotalConcentrations + solidsLength + 2,ctx.nFixedTotalConcentrations + solidsLength + 2);
            var ionicComponent = ionicStrengthComponentDerivatives(ctx);
            var componentIonic = componentIonicStrengthDerivatives(ctx);

            //copy ionic strength - component and component -ionic strength derivatives
            for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
                jacobian[i][(ctx.nFixedTotalConcentrations + solidsLength + 1)] = ionicComponent[i];
                jacobian[(ctx.nFixedTotalConcentrations + solidsLength + 1)][i] = componentIonic[i];
            }

            //copy ionic strength - solid and solid - ionic strength derivatives
            for (i = 0; i < solidsLength; i++) {
                jacobian[i][(ctx.nFixedTotalConcentrations + solidsLength + 1)] = 0.0;
                jacobian[(ctx.nFixedTotalConcentrations + solidsLength + 1)][i] = 0.0;
            }

            //ionic strength - ionic strength derivative
            jacobian[(ctx.nFixedTotalConcentrations + solidsLength + 1)][(ctx.nFixedTotalConcentrations + solidsLength + 1)] = ionicStrengthIonicStrengthDerivative(ctx);

            //ionic strength - solvent and solvent - ionic strength derivatives
            jacobian[(ctx.nFixedTotalConcentrations + solidsLength + 1)][(ctx.nFixedTotalConcentrations + solidsLength)] = solventIonicStrengthDerivative(ctx);
            jacobian[(ctx.nFixedTotalConcentrations + solidsLength)][(ctx.nFixedTotalConcentrations + solidsLength + 1)] = ionicStrengthSolventDerivative(ctx);
        }
        var solventComponent = solventComponentsDerivatives(ctx);
        var componentSolvent = componentSolventDerivatives(ctx);
        var solidSolvent = solidSolventDerivatives(ctx, solids);

        //copy solvent-component and component-solvent derivatives
        for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        jacobian[i][(ctx.nFixedTotalConcentrations + solidsLength)] = solventComponent[i];
        jacobian[(ctx.nFixedTotalConcentrations + solidsLength)][i] = componentSolvent[i];
    }

        //copy solid-solvent derivatives and set solvent-solid derivatives to zero
        for (i = 0; i < solidsLength; i++) {
        jacobian[(ctx.nFixedTotalConcentrations + solidsLength)][(i + ctx.nFixedTotalConcentrations)] = solidSolvent[i];
        jacobian[(i + ctx.nFixedTotalConcentrations)][(ctx.nFixedTotalConcentrations + solidsLength)] = 0.0;
    }
        //solvent - solvent derivative
        jacobian[(ctx.nFixedTotalConcentrations + solidsLength)][(ctx.nFixedTotalConcentrations + solidsLength)] = solventSolventDerivative(ctx);
    }
    else {
        jacobian = initialize2DArray(ctx.nFixedTotalConcentrations + solidsLength, ctx.nFixedTotalConcentrations + solidsLength);
    }

    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        //copy component - component derivatives
        for (j = i; j < ctx.nFixedTotalConcentrations; j++) {
        jacobian[i][j] = componentComponent[i][j];
        jacobian[j][i] = componentComponent[j][i];
    }

        //copy component - solid and solid - component derivatives
        for (j = 0; j < solidsLength; j++) {
        jacobian[i][(ctx.nFixedTotalConcentrations + j)] = solidComponent[i][j];
        jacobian[(ctx.nFixedTotalConcentrations + j)][i] = componentSolid[j][i];
    }
    }

    //copy solid - solid derivatives (zero-valued)
    for (i = 0; i < solidsLength; i++) {
        for (j = i; j < solidsLength; j++) {
            jacobian[(ctx.nFixedTotalConcentrations + i)][(ctx.nFixedTotalConcentrations + j)] = 0.0;
            jacobian[(ctx.nFixedTotalConcentrations + j)][(ctx.nFixedTotalConcentrations + i)] = 0.0;
        }
    }
    return jacobian;
}

function equilibrateNoSolids(ctx, correctActivities, fixedIonicStrength, maxIterations, precision) {
    var noSolids = [];
    return equilibrate(ctx, correctActivities, fixedIonicStrength, noSolids, maxIterations, precision);
}

//WARNING unwarranted behavior if correctActivities=false and fixedIonicStrength=true. Prevent such ocurrence in the public method
//Returns the number of iterations run
function equilibrate(ctx, correctActivities, fixedIonicStrength, solids, maxIterations, precision) {
    if(arguments.length <= 5) return equilibrateNoSolids.apply(null, arguments);
    if (hasZero(ctx.fixedTotalComponentConcentrations, ctx.nFixedTotalConcentrations)) {
        var reducedSystem = ctx.removeZeroConcentrations();
        var result = equilibrate(reducedSystem, correctActivities, fixedIonicStrength, solids, maxIterations, precision);

        //copy solution species concentrations
        var i, j,k = 0, present;

        var solutionConcentrations = reducedSystem.getSolutionSpeciesConcentrations();
        for (i = 0; i < ctx.nSolutionSpecies; i++) {
            present = true;
            for (j = 0; j < ctx.nComponents; j++) { //nFixedTotalConcentrations?
                if ((ctx.solutionSpeciesCoefficients[i][j] != 0.0) && (ctx.componentActivities[j] == 0.0)) {
                    present = false;
                    ctx.solutionSpeciesConcentrations[i] = 0.0;
                    break;
                }
            }
            if (present) {
                ctx.solutionSpeciesConcentrations[i] = solutionConcentrations[k];
                k++;
            }
        }

        //copy solid species concentrations
        k = 0;
        var solidConcentrations = reducedSystem.getSolidsConcentrations();
        for (i = 0; i < ctx.nSolids; i++) {
            present = true;
            for (j = 0; j < ctx.nComponents; j++) {
                if ((ctx.solidSpeciesCoefficients[i][j] != 0.0) && (ctx.componentActivities[j] == 0.0)) {
                    present = false;
                    ctx.solidSpeciesConcentrations[i] = 0.0;
                    break;
                }
            }
            if (present) {
                ctx.solidSpeciesConcentrations[i] = solidConcentrations[k];
                k++;
            }
        }

        //copy component activities
        var nonZeroEquilibriumActivities = reducedSystem.getComponentActivities();
        k = 0;
        for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
            if (ctx.fixedTotalComponentConcentrations[i] != 0.0) {
                ctx.componentActivities[i] = nonZeroEquilibriumActivities[k];
                k++;
            }
        }

        //copy ionic strength
        if (correctActivities) {
            ctx.ionicStrength = reducedSystem.getIonicStrength();
        }
        return result;
    }

    var iterations = 1;
    var solidsLength = solids.length;

    //species concentrations must be updated before balancing
    ctx.calculateSolutionSpeciesConcentrations(correctActivities);
    var totalError = balance(ctx, correctActivities, fixedIonicStrength, solids);

    //last condition in the while statement (second term of the or) may be unnecessary... or, on the contrary, a similar condition on solution species may be necessary
    while ((iterations <= maxIterations) && (maximumRelativeError(ctx, totalError, solids, correctActivities, fixedIonicStrength) > precision))
    {
        var jacobian = new Matrix(balanceJacobian(ctx, correctActivities, fixedIonicStrength, solids));
        var inverseJacobian = jacobian.inverse().to2DArray();
        var shifts;
        //computation of shift vector with an adequately sized product and activity correction-contingent shifts
        if (correctActivities)
        {
            if (fixedIonicStrength) {
                shifts = product(totalError, inverseJacobian, ctx.nFixedTotalConcentrations + solidsLength + 1, ctx.nFixedTotalConcentrations + solidsLength + 1);
            }
            else {
                shifts = product(totalError, inverseJacobian, ctx.nFixedTotalConcentrations + solidsLength + 2, ctx.nFixedTotalConcentrations + solidsLength + 2);
                //shift ionic strength
                ctx.ionicStrength += shifts[(ctx.nFixedTotalConcentrations + solidsLength + 1)];
            }

            //shift solvent activity
            ctx.componentActivities[(ctx.nComponents - 1)] += shifts[(ctx.nFixedTotalConcentrations + solidsLength)];
        }
        else {
            shifts = product(totalError, inverseJacobian, ctx.nFixedTotalConcentrations + solidsLength, ctx.nFixedTotalConcentrations + solidsLength);
        }

        //shift component activities
        ctx.componentActivities = sum(ctx.componentActivities, shifts, ctx.nFixedTotalConcentrations, true);

        var solidIndex = ctx.nFixedTotalConcentrations;
        for (i=0; i<solids.length; i++) {
        ctx.solidSpeciesConcentrations[solids[i]] += shifts[solidIndex];
        solidIndex++;
    }

        //update species concentrations
        ctx.calculateSolutionSpeciesConcentrations(correctActivities);
        totalError = balance(ctx, correctActivities, fixedIonicStrength, solids);
        iterations++;
    }
    if (iterations === 1) {
        //console.log("Equilibrium reached after " + iterations + " iterations");
        return iterations;
    }
    if (iterations > maxIterations) {
        //console.log("maximum number of iterations reached without convergence");
    }
    else {
        //console.log("Equilibrium reached after " + (iterations - 1) + " iterations");
    }
    return iterations - 1;
}

//relative error on total concentrations
function maximumRelativeError(ctx, errors, solids, correctActivities, fixedIonicStrength) {
    var  maxError = 0.0, i;

    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        maxError = Math.max(maxError, Math.abs(errors[i] / ctx.fixedTotalComponentConcentrations[i]));
    }
    var solidIndex = ctx.nFixedTotalConcentrations;

    //relative error on solid solubility products
    for (i=0; i<solids.length; i++) {
        maxError = Math.max(maxError, Math.abs(errors[solidIndex] / ctx.solidSpeciesConstants[solids[i]]));
        solidIndex++;
    }
    if (correctActivities) {
        //relative error on solvent activity
        maxError = Math.max(maxError, Math.abs(errors[solidIndex] / ctx.componentActivities[(ctx.nComponents - 1)]));
        if (!fixedIonicStrength) {
            //relative error on ionic strength
            maxError = Math.max(maxError, Math.abs(errors[(solidIndex + 1)] / ctx.ionicStrength));
        }
    }
    return maxError;
}

function mostInsoluble(ctx) {
    var saturationIndices = ctx.saturationIndices();
    var result = 0, i;
    for (i = 0; i < ctx.nSolids; i++) {
        if (saturationIndices[i] > saturationIndices[result]) {
            result = i;
        }
    }
    return result;
}

//returns the number of iterations in the last run of equilibrate (the one that ends with no oversaturated/insaturated solid) or
//maxIterations if maximum number of precipitation cycles was exausted
function calculateOnePoint(ctx, correctActivities, fixedIonicStrength, maxIterations, precision)
{
    var currentSolid = 0;
    var solidsToPrecipitate = [];
    var precipitationCycles = 0;
    var i;
    //console.log("Iterating solution towards equilibrium...");
    var result = equilibrate(ctx, correctActivities, fixedIonicStrength, solidsToPrecipitate, maxIterations, precision);

    if (ctx.nSolids > 0) {
        var saturationIndices = ctx.saturationIndices();

        //disolve all insaturated
        for (i = 0; i < ctx.nSolids; i++) {
            if ((ctx.solidSpeciesConcentrations[i] > 0.0) && (1.0 - saturationIndices[i] > precision)) {
                disolve(ctx, i, correctActivities);
            }
        }
        result = equilibrate(ctx,correctActivities, fixedIonicStrength, maxIterations, precision);

        saturationIndices = ctx.saturationIndices();
        currentSolid = mostInsoluble(ctx);

        while ((saturationIndices[currentSolid] - 1.0 > precision) && (precipitationCycles <= ctx.nSolids))
        {
            precipitationCycles++;
            //console.log("Solid " + currentSolid + " is over-saturated and will be included in the global balance");
            //console.log("Iterating the extended system towards equilibrium...");
            solidsToPrecipitate = solidsToPrecipitate.slice(0, solidsToPrecipitate.length + 1);
            solidsToPrecipitate[(solidsToPrecipitate.length - 1)] = currentSolid;
            equilibrate(ctx, correctActivities, fixedIonicStrength, solidsToPrecipitate, maxIterations, precision);
            saturationIndices = ctx.saturationIndices();
            for (i = 0; i < ctx.nSolids; i++) {
                if ((ctx.solidSpeciesConcentrations[i] > 0.0) && (1.0 - saturationIndices[i] > precision)) {
                    disolve(ctx, i, correctActivities);
                }
            }
            result = equilibrate(ctx, correctActivities, fixedIonicStrength, maxIterations, precision);
            saturationIndices = ctx.saturationIndices();

            currentSolid = mostInsoluble(ctx);
        }
    }

    if (precipitationCycles > ctx.nSolids) {
        //console.log("Solid phases could not be equilibrated with the solution");
        return maxIterations;
    }
    //console.log("All solid phases are now in equilibrium with the solution");
    return result;
}

function hasZero(arr, nElements) {
    var i;
    for (i = 0; i < nElements; i++) {
        if (arr[i] == 0.0) {
            return true;
        }
    }
    return false;
}

function hasNegative(arr, nElements) {
    for (var i = 0; i < nElements; i++) {
        if (arr[i] < 0.0 || arr[i] === Infinity || arr[i] === -Infinity || isNaN(arr[i]))
            return true;
    }
    return false;
}

function hasError(ctx, val, nElements) {
    if(argements.length === 1) {
        return (hasError(ctx.componentActivities, ctx.nComponents)) ||
            (hasError(getSolutionSpeciesConcentrations(), ctx.nSolutionSpecies)) ||
            (hasError(getSolidsConcentrations(), ctx.nSolids)) ||
            (hasError(getIonicStrength()));
    }
    if(arguments.length === 2) {
        return val === Infinity || val === -Infinity;
    }
    if(arguments.length === 3) {
        if(typeof val !== Array) return true;
        for (var i = 0; i < nElements; i++) {
            if (val[i] === Infinity || val[i] === -Infinity)
                return true;
        }
        return false;
    }

}

function product(a1,  a2, nRows, nColumns) {
    var result, i, j;
    if(Array.isArray(a1) && Array.isArray(a1[0])) {
        result = initialize1DArray(a1.length);
        for (i = 0; i < nRows; i++) {
            result[i] = 0.0;
            for (j = 0; j < nColumns; j++) {
                result[i] += a1[i][j] * a2[j];
            }
        }
    }
    else if(Array.isArray(a2) && Array.isArray(a2[0])) {
        result = initialize1DArray(a2[0].length);
        for (i = 0; i < nColumns; i++) {
            result[i] = 0.0;
            for (j = 0; j < nRows; j++) {
                result[i] += a2[j][i] * a1[j];
            }
        }
        return result;
    }

    return result;
}

function sum(v1, v2, nElements, inPlace) {
    var result;
    if(inPlace) {
        result = v1.slice();
    }
    else {
        result = initialize1DArray(v1.length);
    }
    for (var i = 0; i < nElements; i++) {
        result[i] = v1[i] + v2[i];
    }
    return result;
}

function minus(v1, v2, nElements, inPlace) {
    var result;
    if(inPlace) {
        result = v1.slice();
    }
    else {
        result = initialize1DArray(v1.length);
    }
    for (var i = 0; i < nElements; i++) {
        result[i] = v1[i] - v2[i];
    }
    return result;
}

function deepCopy(doubleArray, nRows, nCols) {
    var result = initialize1DArray(nRows);
    for(var i=0; i<doubleArray.length; i++) {
        result[i] = doubleArray[i].slice();
    }
    return result;
}

function optionsAsProperties(ctx, options) {
    for(var key in options) {
        ctx[key] = options[key];
    }
}

function initialize2DArray(nRow, nCol) {
    var result = new Array(nRow);
    for(var i=0; i<nRow; i++) {
        result[i] = initialize1DArray(nCol);
    }
    return result;
}

function initialize1DArray(n) {
    return Array.apply(null, new Array(n)).map(Number.prototype.valueOf,0);
}

function rndWithSeed(seed) {
    var mt = new mersenneTwister(seed);
    return mt.random.bind(mt);
}

function constantRandom(constant) {
    return function() {
        return constant;
    };
}

module.exports = EquilibriumCalculator;
},{"mersenne-twister":2,"ml-matrix":4}],2:[function(require,module,exports){
/*
  https://github.com/banksean wrapped Makoto Matsumoto and Takuji Nishimura's code in a namespace
  so it's better encapsulated. Now you can have multiple random number generators
  and they won't stomp all over eachother's state.
  
  If you want to use this as a substitute for Math.random(), use the random()
  method like so:
  
  var m = new MersenneTwister();
  var randomNumber = m.random();
  
  You can also call the other genrand_{foo}() methods on the instance.
 
  If you want to use a specific seed in order to get a repeatable random
  sequence, pass an integer into the constructor:
 
  var m = new MersenneTwister(123);
 
  and that will always produce the same random sequence.
 
  Sean McCullough (banksean@gmail.com)
*/
 
/* 
   A C-program for MT19937, with initialization improved 2002/1/26.
   Coded by Takuji Nishimura and Makoto Matsumoto.
 
   Before using, initialize the state by using init_seed(seed)  
   or init_by_array(init_key, key_length).
 
   Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
   All rights reserved.                          
 
   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions
   are met:
 
     1. Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer.
 
     2. Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.
 
     3. The names of its contributors may not be used to endorse or promote 
        products derived from this software without specific prior written 
        permission.
 
   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
   "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
   LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
   A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
   CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
   EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
   PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
   PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 
 
   Any feedback is very welcome.
   http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
   email: m-mat @ math.sci.hiroshima-u.ac.jp (remove space)
*/
 
var MersenneTwister = function(seed) {
	if (seed == undefined) {
		seed = new Date().getTime();
	} 

	/* Period parameters */  
	this.N = 624;
	this.M = 397;
	this.MATRIX_A = 0x9908b0df;   /* constant vector a */
	this.UPPER_MASK = 0x80000000; /* most significant w-r bits */
	this.LOWER_MASK = 0x7fffffff; /* least significant r bits */

	this.mt = new Array(this.N); /* the array for the state vector */
	this.mti=this.N+1; /* mti==N+1 means mt[N] is not initialized */

	this.init_seed(seed);
}  

/* initializes mt[N] with a seed */
/* origin name init_genrand */
MersenneTwister.prototype.init_seed = function(s) {
	this.mt[0] = s >>> 0;
	for (this.mti=1; this.mti<this.N; this.mti++) {
		var s = this.mt[this.mti-1] ^ (this.mt[this.mti-1] >>> 30);
		this.mt[this.mti] = (((((s & 0xffff0000) >>> 16) * 1812433253) << 16) + (s & 0x0000ffff) * 1812433253)
		+ this.mti;
		/* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */
		/* In the previous versions, MSBs of the seed affect   */
		/* only MSBs of the array mt[].                        */
		/* 2002/01/09 modified by Makoto Matsumoto             */
		this.mt[this.mti] >>>= 0;
		/* for >32 bit machines */
	}
}

/* initialize by an array with array-length */
/* init_key is the array for initializing keys */
/* key_length is its length */
/* slight change for C++, 2004/2/26 */
MersenneTwister.prototype.init_by_array = function(init_key, key_length) {
	var i, j, k;
	this.init_seed(19650218);
	i=1; j=0;
	k = (this.N>key_length ? this.N : key_length);
	for (; k; k--) {
		var s = this.mt[i-1] ^ (this.mt[i-1] >>> 30)
		this.mt[i] = (this.mt[i] ^ (((((s & 0xffff0000) >>> 16) * 1664525) << 16) + ((s & 0x0000ffff) * 1664525)))
		+ init_key[j] + j; /* non linear */
		this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */
		i++; j++;
		if (i>=this.N) { this.mt[0] = this.mt[this.N-1]; i=1; }
		if (j>=key_length) j=0;
	}
	for (k=this.N-1; k; k--) {
		var s = this.mt[i-1] ^ (this.mt[i-1] >>> 30);
		this.mt[i] = (this.mt[i] ^ (((((s & 0xffff0000) >>> 16) * 1566083941) << 16) + (s & 0x0000ffff) * 1566083941))
		- i; /* non linear */
		this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */
		i++;
		if (i>=this.N) { this.mt[0] = this.mt[this.N-1]; i=1; }
	}

	this.mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */ 
}

/* generates a random number on [0,0xffffffff]-interval */
/* origin name genrand_int32 */
MersenneTwister.prototype.random_int = function() {
	var y;
	var mag01 = new Array(0x0, this.MATRIX_A);
	/* mag01[x] = x * MATRIX_A  for x=0,1 */

	if (this.mti >= this.N) { /* generate N words at one time */
		var kk;

		if (this.mti == this.N+1)  /* if init_seed() has not been called, */
			this.init_seed(5489);  /* a default initial seed is used */

		for (kk=0;kk<this.N-this.M;kk++) {
			y = (this.mt[kk]&this.UPPER_MASK)|(this.mt[kk+1]&this.LOWER_MASK);
			this.mt[kk] = this.mt[kk+this.M] ^ (y >>> 1) ^ mag01[y & 0x1];
		}
		for (;kk<this.N-1;kk++) {
			y = (this.mt[kk]&this.UPPER_MASK)|(this.mt[kk+1]&this.LOWER_MASK);
			this.mt[kk] = this.mt[kk+(this.M-this.N)] ^ (y >>> 1) ^ mag01[y & 0x1];
		}
		y = (this.mt[this.N-1]&this.UPPER_MASK)|(this.mt[0]&this.LOWER_MASK);
		this.mt[this.N-1] = this.mt[this.M-1] ^ (y >>> 1) ^ mag01[y & 0x1];

		this.mti = 0;
	}

	y = this.mt[this.mti++];

	/* Tempering */
	y ^= (y >>> 11);
	y ^= (y << 7) & 0x9d2c5680;
	y ^= (y << 15) & 0xefc60000;
	y ^= (y >>> 18);

	return y >>> 0;
}

/* generates a random number on [0,0x7fffffff]-interval */
/* origin name genrand_int31 */
MersenneTwister.prototype.random_int31 = function() {
	return (this.random_int()>>>1);
}

/* generates a random number on [0,1]-real-interval */
/* origin name genrand_real1 */
MersenneTwister.prototype.random_incl = function() {
	return this.random_int()*(1.0/4294967295.0); 
	/* divided by 2^32-1 */ 
}

/* generates a random number on [0,1)-real-interval */
MersenneTwister.prototype.random = function() {
	return this.random_int()*(1.0/4294967296.0); 
	/* divided by 2^32 */
}

/* generates a random number on (0,1)-real-interval */
/* origin name genrand_real3 */
MersenneTwister.prototype.random_excl = function() {
	return (this.random_int() + 0.5)*(1.0/4294967296.0); 
	/* divided by 2^32 */
}

/* generates a random number on [0,1) with 53-bit resolution*/
/* origin name genrand_res53 */
MersenneTwister.prototype.random_long = function() { 
	var a=this.random_int()>>>5, b=this.random_int()>>>6; 
	return(a*67108864.0+b)*(1.0/9007199254740992.0); 
} 

/* These real versions are due to Isaku Wada, 2002/01/09 added */

module.exports = MersenneTwister;

},{}],3:[function(require,module,exports){
'use strict';

var Matrix = require('./matrix');

// https://github.com/lutzroeder/Mapack/blob/master/Source/EigenvalueDecomposition.cs
function EigenvalueDecomposition(matrix) {
    matrix = Matrix.checkMatrix(matrix);
    if (!matrix.isSquare()) {
        throw new Error('Matrix is not a square matrix');
    }

    var n = matrix.columns,
        V = Matrix.zeros(n, n),
        d = new Array(n),
        e = new Array(n),
        value = matrix,
        i, j;

    if (matrix.isSymmetric()) {
        for (i = 0; i < n; i++) {
            for (j = 0; j < n; j++) {
                V[i][j] = value[i][j];
            }
        }
        tred2(n, e, d, V);
        tql2(n, e, d, V);
    }
    else {
        var H = Matrix.zeros(n, n),
            ort = new Array(n);
        for (j = 0; j < n; j++) {
            for (i = 0; i < n; i++) {
                H[i][j] = value[i][j];
            }
        }
        orthes(n, H, ort, V);
        hqr2(n, e, d, V, H);
    }

    return new EigenvalueDecompositionResult(n, e, d, V);
}

function tred2(n, e, d, V) {

    var f, g, h, i, j, k,
        hh, scale;

    for (j = 0; j < n; j++) {
        d[j] = V[n - 1][j];
    }

    for (i = n - 1; i > 0; i--) {
        scale = 0;
        h = 0;
        for (k = 0; k < i; k++) {
            scale = scale + Math.abs(d[k]);
        }

        if (scale === 0) {
            e[i] = d[i - 1];
            for (j = 0; j < i; j++) {
                d[j] = V[i - 1][j];
                V[i][j] = 0;
                V[j][i] = 0;
            }
        } else {
            for (k = 0; k < i; k++) {
                d[k] /= scale;
                h += d[k] * d[k];
            }

            f = d[i - 1];
            g = Math.sqrt(h);
            if (f > 0) {
                g = -g;
            }

            e[i] = scale * g;
            h = h - f * g;
            d[i - 1] = f - g;
            for (j = 0; j < i; j++) {
                e[j] = 0;
            }

            for (j = 0; j < i; j++) {
                f = d[j];
                V[j][i] = f;
                g = e[j] + V[j][j] * f;
                for (k = j + 1; k <= i - 1; k++) {
                    g += V[k][j] * d[k];
                    e[k] += V[k][j] * f;
                }
                e[j] = g;
            }

            f = 0;
            for (j = 0; j < i; j++) {
                e[j] /= h;
                f += e[j] * d[j];
            }

            hh = f / (h + h);
            for (j = 0; j < i; j++) {
                e[j] -= hh * d[j];
            }

            for (j = 0; j < i; j++) {
                f = d[j];
                g = e[j];
                for (k = j; k <= i - 1; k++) {
                    V[k][j] -= (f * e[k] + g * d[k]);
                }
                d[j] = V[i - 1][j];
                V[i][j] = 0;
            }
        }
        d[i] = h;
    }

    for (i = 0; i < n - 1; i++) {
        V[n - 1][i] = V[i][i];
        V[i][i] = 1;
        h = d[i + 1];
        if (h !== 0) {
            for (k = 0; k <= i; k++) {
                d[k] = V[k][i + 1] / h;
            }

            for (j = 0; j <= i; j++) {
                g = 0;
                for (k = 0; k <= i; k++) {
                    g += V[k][i + 1] * V[k][j];
                }
                for (k = 0; k <= i; k++) {
                    V[k][j] -= g * d[k];
                }
            }
        }

        for (k = 0; k <= i; k++) {
            V[k][i + 1] = 0;
        }
    }

    for (j = 0; j < n; j++) {
        d[j] = V[n - 1][j];
        V[n - 1][j] = 0;
    }

    V[n - 1][n - 1] = 1;
    e[0] = 0;
}

function tql2(n, e, d, V) {

    var g, h, i, j, k, l, m, p, r,
        dl1, c, c2, c3, el1, s, s2,
        iter;

    for (i = 1; i < n; i++) {
        e[i - 1] = e[i];
    }

    e[n - 1] = 0;

    var f = 0,
        tst1 = 0,
        eps = Math.pow(2, -52);

    for (l = 0; l < n; l++) {
        tst1 = Math.max(tst1, Math.abs(d[l]) + Math.abs(e[l]));
        m = l;
        while (m < n) {
            if (Math.abs(e[m]) <= eps * tst1) {
                break;
            }
            m++;
        }

        if (m > l) {
            iter = 0;
            do {
                iter = iter + 1;

                g = d[l];
                p = (d[l + 1] - g) / (2 * e[l]);
                r = hypotenuse(p, 1);
                if (p < 0) {
                    r = -r;
                }

                d[l] = e[l] / (p + r);
                d[l + 1] = e[l] * (p + r);
                dl1 = d[l + 1];
                h = g - d[l];
                for (i = l + 2; i < n; i++) {
                    d[i] -= h;
                }

                f = f + h;

                p = d[m];
                c = 1;
                c2 = c;
                c3 = c;
                el1 = e[l + 1];
                s = 0;
                s2 = 0;
                for (i = m - 1; i >= l; i--) {
                    c3 = c2;
                    c2 = c;
                    s2 = s;
                    g = c * e[i];
                    h = c * p;
                    r = hypotenuse(p, e[i]);
                    e[i + 1] = s * r;
                    s = e[i] / r;
                    c = p / r;
                    p = c * d[i] - s * g;
                    d[i + 1] = h + s * (c * g + s * d[i]);

                    for (k = 0; k < n; k++) {
                        h = V[k][i + 1];
                        V[k][i + 1] = s * V[k][i] + c * h;
                        V[k][i] = c * V[k][i] - s * h;
                    }
                }

                p = -s * s2 * c3 * el1 * e[l] / dl1;
                e[l] = s * p;
                d[l] = c * p;

            }
            while (Math.abs(e[l]) > eps * tst1);
        }
        d[l] = d[l] + f;
        e[l] = 0;
    }

    for (i = 0; i < n - 1; i++) {
        k = i;
        p = d[i];
        for (j = i + 1; j < n; j++) {
            if (d[j] < p) {
                k = j;
                p = d[j];
            }
        }

        if (k !== i) {
            d[k] = d[i];
            d[i] = p;
            for (j = 0; j < n; j++) {
                p = V[j][i];
                V[j][i] = V[j][k];
                V[j][k] = p;
            }
        }
    }
}

function orthes(n, H, ort, V) {

    var low = 0,
        high = n - 1,
        f, g, h, i, j, m,
        scale;

    for (m = low + 1; m <= high - 1; m++) {
        scale = 0;
        for (i = m; i <= high; i++) {
            scale = scale + Math.abs(H[i][m - 1]);
        }

        if (scale !== 0) {
            h = 0;
            for (i = high; i >= m; i--) {
                ort[i] = H[i][m - 1] / scale;
                h += ort[i] * ort[i];
            }

            g = Math.sqrt(h);
            if (ort[m] > 0) {
                g = -g;
            }

            h = h - ort[m] * g;
            ort[m] = ort[m] - g;

            for (j = m; j < n; j++) {
                f = 0;
                for (i = high; i >= m; i--) {
                    f += ort[i] * H[i][j];
                }

                f = f / h;
                for (i = m; i <= high; i++) {
                    H[i][j] -= f * ort[i];
                }
            }

            for (i = 0; i <= high; i++) {
                f = 0;
                for (j = high; j >= m; j--) {
                    f += ort[j] * H[i][j];
                }

                f = f / h;
                for (j = m; j <= high; j++) {
                    H[i][j] -= f * ort[j];
                }
            }

            ort[m] = scale * ort[m];
            H[m][m - 1] = scale * g;
        }
    }

    for (i = 0; i < n; i++) {
        for (j = 0; j < n; j++) {
            V[i][j] = (i === j ? 1 : 0);
        }
    }

    for (m = high - 1; m >= low + 1; m--) {
        if (H[m][m - 1] !== 0) {
            for (i = m + 1; i <= high; i++) {
                ort[i] = H[i][m - 1];
            }

            for (j = m; j <= high; j++) {
                g = 0;
                for (i = m; i <= high; i++) {
                    g += ort[i] * V[i][j];
                }

                g = (g / ort[m]) / H[m][m - 1];
                for (i = m; i <= high; i++) {
                    V[i][j] += g * ort[i];
                }
            }
        }
    }
}

function hqr2(nn, e, d, V, H) {
    var n = nn - 1,
        low = 0,
        high = nn - 1,
        eps = Math.pow(2, -52),
        exshift = 0,
        norm = 0,
        p = 0,
        q = 0,
        r = 0,
        s = 0,
        z = 0,
        iter = 0,
        i, j, k, l, m, t, w, x, y,
        ra, sa, vr, vi,
        notlast, cdivres;

    for (i = 0; i < nn; i++) {
        if (i < low || i > high) {
            d[i] = H[i][i];
            e[i] = 0;
        }

        for (j = Math.max(i - 1, 0); j < nn; j++) {
            norm = norm + Math.abs(H[i][j]);
        }
    }

    while (n >= low) {
        l = n;
        while (l > low) {
            s = Math.abs(H[l - 1][l - 1]) + Math.abs(H[l][l]);
            if (s === 0) {
                s = norm;
            }
            if (Math.abs(H[l][l - 1]) < eps * s) {
                break;
            }
            l--;
        }

        if (l === n) {
            H[n][n] = H[n][n] + exshift;
            d[n] = H[n][n];
            e[n] = 0;
            n--;
            iter = 0;
        } else if (l === n - 1) {
            w = H[n][n - 1] * H[n - 1][n];
            p = (H[n - 1][n - 1] - H[n][n]) / 2;
            q = p * p + w;
            z = Math.sqrt(Math.abs(q));
            H[n][n] = H[n][n] + exshift;
            H[n - 1][n - 1] = H[n - 1][n - 1] + exshift;
            x = H[n][n];

            if (q >= 0) {
                z = (p >= 0) ? (p + z) : (p - z);
                d[n - 1] = x + z;
                d[n] = d[n - 1];
                if (z !== 0) {
                    d[n] = x - w / z;
                }
                e[n - 1] = 0;
                e[n] = 0;
                x = H[n][n - 1];
                s = Math.abs(x) + Math.abs(z);
                p = x / s;
                q = z / s;
                r = Math.sqrt(p * p + q * q);
                p = p / r;
                q = q / r;

                for (j = n - 1; j < nn; j++) {
                    z = H[n - 1][j];
                    H[n - 1][j] = q * z + p * H[n][j];
                    H[n][j] = q * H[n][j] - p * z;
                }

                for (i = 0; i <= n; i++) {
                    z = H[i][n - 1];
                    H[i][n - 1] = q * z + p * H[i][n];
                    H[i][n] = q * H[i][n] - p * z;
                }

                for (i = low; i <= high; i++) {
                    z = V[i][n - 1];
                    V[i][n - 1] = q * z + p * V[i][n];
                    V[i][n] = q * V[i][n] - p * z;
                }
            } else {
                d[n - 1] = x + p;
                d[n] = x + p;
                e[n - 1] = z;
                e[n] = -z;
            }

            n = n - 2;
            iter = 0;
        } else {
            x = H[n][n];
            y = 0;
            w = 0;
            if (l < n) {
                y = H[n - 1][n - 1];
                w = H[n][n - 1] * H[n - 1][n];
            }

            if (iter === 10) {
                exshift += x;
                for (i = low; i <= n; i++) {
                    H[i][i] -= x;
                }
                s = Math.abs(H[n][n - 1]) + Math.abs(H[n - 1][n - 2]);
                x = y = 0.75 * s;
                w = -0.4375 * s * s;
            }

            if (iter === 30) {
                s = (y - x) / 2;
                s = s * s + w;
                if (s > 0) {
                    s = Math.sqrt(s);
                    if (y < x) {
                        s = -s;
                    }
                    s = x - w / ((y - x) / 2 + s);
                    for (i = low; i <= n; i++) {
                        H[i][i] -= s;
                    }
                    exshift += s;
                    x = y = w = 0.964;
                }
            }

            iter = iter + 1;

            m = n - 2;
            while (m >= l) {
                z = H[m][m];
                r = x - z;
                s = y - z;
                p = (r * s - w) / H[m + 1][m] + H[m][m + 1];
                q = H[m + 1][m + 1] - z - r - s;
                r = H[m + 2][m + 1];
                s = Math.abs(p) + Math.abs(q) + Math.abs(r);
                p = p / s;
                q = q / s;
                r = r / s;
                if (m === l) {
                    break;
                }
                if (Math.abs(H[m][m - 1]) * (Math.abs(q) + Math.abs(r)) < eps * (Math.abs(p) * (Math.abs(H[m - 1][m - 1]) + Math.abs(z) + Math.abs(H[m + 1][m + 1])))) {
                    break;
                }
                m--;
            }

            for (i = m + 2; i <= n; i++) {
                H[i][i - 2] = 0;
                if (i > m + 2) {
                    H[i][i - 3] = 0;
                }
            }

            for (k = m; k <= n - 1; k++) {
                notlast = (k !== n - 1);
                if (k !== m) {
                    p = H[k][k - 1];
                    q = H[k + 1][k - 1];
                    r = (notlast ? H[k + 2][k - 1] : 0);
                    x = Math.abs(p) + Math.abs(q) + Math.abs(r);
                    if (x !== 0) {
                        p = p / x;
                        q = q / x;
                        r = r / x;
                    }
                }

                if (x === 0) {
                    break;
                }

                s = Math.sqrt(p * p + q * q + r * r);
                if (p < 0) {
                    s = -s;
                }

                if (s !== 0) {
                    if (k !== m) {
                        H[k][k - 1] = -s * x;
                    } else if (l !== m) {
                        H[k][k - 1] = -H[k][k - 1];
                    }

                    p = p + s;
                    x = p / s;
                    y = q / s;
                    z = r / s;
                    q = q / p;
                    r = r / p;

                    for (j = k; j < nn; j++) {
                        p = H[k][j] + q * H[k + 1][j];
                        if (notlast) {
                            p = p + r * H[k + 2][j];
                            H[k + 2][j] = H[k + 2][j] - p * z;
                        }

                        H[k][j] = H[k][j] - p * x;
                        H[k + 1][j] = H[k + 1][j] - p * y;
                    }

                    for (i = 0; i <= Math.min(n, k + 3); i++) {
                        p = x * H[i][k] + y * H[i][k + 1];
                        if (notlast) {
                            p = p + z * H[i][k + 2];
                            H[i][k + 2] = H[i][k + 2] - p * r;
                        }

                        H[i][k] = H[i][k] - p;
                        H[i][k + 1] = H[i][k + 1] - p * q;
                    }

                    for (i = low; i <= high; i++) {
                        p = x * V[i][k] + y * V[i][k + 1];
                        if (notlast) {
                            p = p + z * V[i][k + 2];
                            V[i][k + 2] = V[i][k + 2] - p * r;
                        }

                        V[i][k] = V[i][k] - p;
                        V[i][k + 1] = V[i][k + 1] - p * q;
                    }
                }
            }
        }
    }

    if (norm === 0) {
        return;
    }

    for (n = nn - 1; n >= 0; n--) {
        p = d[n];
        q = e[n];

        if (q === 0) {
            l = n;
            H[n][n] = 1;
            for (i = n - 1; i >= 0; i--) {
                w = H[i][i] - p;
                r = 0;
                for (j = l; j <= n; j++) {
                    r = r + H[i][j] * H[j][n];
                }

                if (e[i] < 0) {
                    z = w;
                    s = r;
                } else {
                    l = i;
                    if (e[i] === 0) {
                        H[i][n] = (w !== 0) ? (-r / w) : (-r / (eps * norm));
                    } else {
                        x = H[i][i + 1];
                        y = H[i + 1][i];
                        q = (d[i] - p) * (d[i] - p) + e[i] * e[i];
                        t = (x * s - z * r) / q;
                        H[i][n] = t;
                        H[i + 1][n] = (Math.abs(x) > Math.abs(z)) ? ((-r - w * t) / x) : ((-s - y * t) / z);
                    }

                    t = Math.abs(H[i][n]);
                    if ((eps * t) * t > 1) {
                        for (j = i; j <= n; j++) {
                            H[j][n] = H[j][n] / t;
                        }
                    }
                }
            }
        } else if (q < 0) {
            l = n - 1;

            if (Math.abs(H[n][n - 1]) > Math.abs(H[n - 1][n])) {
                H[n - 1][n - 1] = q / H[n][n - 1];
                H[n - 1][n] = -(H[n][n] - p) / H[n][n - 1];
            } else {
                cdivres = cdiv(0, -H[n - 1][n], H[n - 1][n - 1] - p, q);
                H[n - 1][n - 1] = cdivres[0];
                H[n - 1][n] = cdivres[1];
            }

            H[n][n - 1] = 0;
            H[n][n] = 1;
            for (i = n - 2; i >= 0; i--) {
                ra = 0;
                sa = 0;
                for (j = l; j <= n; j++) {
                    ra = ra + H[i][j] * H[j][n - 1];
                    sa = sa + H[i][j] * H[j][n];
                }

                w = H[i][i] - p;

                if (e[i] < 0) {
                    z = w;
                    r = ra;
                    s = sa;
                } else {
                    l = i;
                    if (e[i] === 0) {
                        cdivres = cdiv(-ra, -sa, w, q);
                        H[i][n - 1] = cdivres[0];
                        H[i][n] = cdivres[1];
                    } else {
                        x = H[i][i + 1];
                        y = H[i + 1][i];
                        vr = (d[i] - p) * (d[i] - p) + e[i] * e[i] - q * q;
                        vi = (d[i] - p) * 2 * q;
                        if (vr === 0 && vi === 0) {
                            vr = eps * norm * (Math.abs(w) + Math.abs(q) + Math.abs(x) + Math.abs(y) + Math.abs(z));
                        }
                        cdivres = cdiv(x * r - z * ra + q * sa, x * s - z * sa - q * ra, vr, vi);
                        H[i][n - 1] = cdivres[0];
                        H[i][n] = cdivres[1];
                        if (Math.abs(x) > (Math.abs(z) + Math.abs(q))) {
                            H[i + 1][n - 1] = (-ra - w * H[i][n - 1] + q * H[i][n]) / x;
                            H[i + 1][n] = (-sa - w * H[i][n] - q * H[i][n - 1]) / x;
                        } else {
                            cdivres = cdiv(-r - y * H[i][n - 1], -s - y * H[i][n], z, q);
                            H[i + 1][n - 1] = cdivres[0];
                            H[i + 1][n] = cdivres[1];
                        }
                    }

                    t = Math.max(Math.abs(H[i][n - 1]), Math.abs(H[i][n]));
                    if ((eps * t) * t > 1) {
                        for (j = i; j <= n; j++) {
                            H[j][n - 1] = H[j][n - 1] / t;
                            H[j][n] = H[j][n] / t;
                        }
                    }
                }
            }
        }
    }

    for (i = 0; i < nn; i++) {
        if (i < low || i > high) {
            for (j = i; j < nn; j++) {
                V[i][j] = H[i][j];
            }
        }
    }

    for (j = nn - 1; j >= low; j--) {
        for (i = low; i <= high; i++) {
            z = 0;
            for (k = low; k <= Math.min(j, high); k++) {
                z = z + V[i][k] * H[k][j];
            }
            V[i][j] = z;
        }
    }
}

function cdiv(xr, xi, yr, yi) {
    var r, d;
    if (Math.abs(yr) > Math.abs(yi)) {
        r = yi / yr;
        d = yr + r * yi;
        return [(xr + r * xi) / d, (xi - r * xr) / d];
    }
    else {
        r = yr / yi;
        d = yi + r * yr;
        return [(r * xr + xi) / d, (r * xi - xr) / d];
    }
}

function EigenvalueDecompositionResult(n, e, d, V) {
    this.n = n;
    this.e = e;
    this.d = d;
    this.V = V;
}

EigenvalueDecompositionResult.prototype = {
    get realEigenvalues() {
        return this.d;
    },
    get imaginaryEigenvalues() {
        return this.e;
    },
    get eigenvectorMatrix() {
        return this.V;
    },
    get diagonalMatrix() {
        var n = this.n,
            e = this.e,
            d = this.d,
            X = new Matrix(n, n),
            i, j;
        for (i = 0; i < n; i++) {
            for (j = 0; j < n; j++) {
                X[i][j] = 0;
            }
            X[i][i] = d[i];
            if (e[i] > 0) {
                X[i][i + 1] = e[i];
            }
            else if (e[i] < 0) {
                X[i][i - 1] = e[i];
            }
        }
        return X;
    }
};

// https://github.com/lutzroeder/Mapack/blob/master/Source/LuDecomposition.cs
function LuDecomposition(matrix) {
    matrix = Matrix.checkMatrix(matrix);

    var lu = matrix.clone(),
        rows = lu.rows,
        columns = lu.columns,
        pivotVector = new Array(rows),
        pivotSign = 1,
        i, j, k, p, s, t, v,
        LUrowi, LUcolj, kmax;

    for (i = 0; i < rows; i++) {
        pivotVector[i] = i;
    }

    LUcolj = new Array(rows);

    for (j = 0; j < columns; j++) {

        for (i = 0; i < rows; i++) {
            LUcolj[i] = lu[i][j];
        }

        for (i = 0; i < rows; i++) {
            LUrowi = lu[i];
            kmax = Math.min(i, j);
            s = 0;
            for (k = 0; k < kmax; k++) {
                s += LUrowi[k] * LUcolj[k];
            }
            LUrowi[j] = LUcolj[i] -= s;
        }

        p = j;
        for (i = j + 1; i < rows; i++) {
            if (Math.abs(LUcolj[i]) > Math.abs(LUcolj[p])) {
                p = i;
            }
        }

        if (p !== j) {
            for (k = 0; k < columns; k++) {
                t = lu[p][k];
                lu[p][k] = lu[j][k];
                lu[j][k] = t;
            }

            v = pivotVector[p];
            pivotVector[p] = pivotVector[j];
            pivotVector[j] = v;

            pivotSign = -pivotSign;
        }

        if (j < rows && lu[j][j] !== 0) {
            for (i = j + 1; i < rows; i++) {
                lu[i][j] /= lu[j][j];
            }
        }
    }

    return new LuDecompositionResult(lu, pivotVector, pivotSign);

}

function LuDecompositionResult(lu, vector, sign) {
    this.LU = lu;
    this.pivotVector = vector;
    this.pivotSign = sign;
}

LuDecompositionResult.prototype = {
    isSingular: function () {
        var data = this.LU,
            col = data.columns;
        for (var j = 0; j < col; j++) {
            if (data[j][j] === 0) {
                return true;
            }
        }
        return false;
    },
    get determinant() {
        var data = this.LU;
        if (!data.isSquare())
            throw new Error('Matrix must be square');
        var determinant = this.pivotSign, col = data.columns;
        for (var j = 0; j < col; j++)
            determinant *= data[j][j];
        return determinant;
    },
    get lowerTriangularFactor() {
        var data = this.LU,
            rows = data.rows,
            columns = data.columns,
            X = new Matrix(rows, columns);
        for (var i = 0; i < rows; i++) {
            for (var j = 0; j < columns; j++) {
                if (i > j) {
                    X[i][j] = data[i][j];
                } else if (i === j) {
                    X[i][j] = 1;
                } else {
                    X[i][j] = 0;
                }
            }
        }
        return X;
    },
    get upperTriangularFactor() {
        var data = this.LU,
            rows = data.rows,
            columns = data.columns,
            X = new Matrix(rows, columns);
        for (var i = 0; i < rows; i++) {
            for (var j = 0; j < columns; j++) {
                if (i <= j) {
                    X[i][j] = data[i][j];
                } else {
                    X[i][j] = 0;
                }
            }
        }
        return X;
    },
    get pivotPermutationVector() {
        return this.pivotVector.slice();
    },
    solve: function (value) {
        value = Matrix.checkMatrix(value);

        var lu = this.LU,
            rows = lu.rows;

        if (rows !== value.rows)
            throw new Error('Invalid matrix dimensions');
        if (this.isSingular())
            throw new Error('LU matrix is singular');

        var count = value.columns,
            X = value.subMatrixRow(this.pivotVector, 0, count - 1),
            columns = lu.columns,
            i, j, k;

        for (k = 0; k < columns; k++) {
            for (i = k + 1; i < columns; i++) {
                for (j = 0; j < count; j++) {
                    X[i][j] -= X[k][j] * lu[i][k];
                }
            }
        }
        for (k = columns - 1; k >= 0; k--) {
            for (j = 0; j < count; j++) {
                X[k][j] /= lu[k][k];
            }
            for (i = 0; i < k; i++) {
                for (j = 0; j < count; j++) {
                    X[i][j] -= X[k][j] * lu[i][k];
                }
            }
        }
        return X;
    }
};

//https://github.com/lutzroeder/Mapack/blob/master/Source/QrDecomposition.cs
function QrDecomposition(value) {
    value = Matrix.checkMatrix(value)

    var qr = value.clone(),
        m = value.rows,
        n = value.columns,
        rdiag = new Array(n),
        i, j, k, s;

    for (k = 0; k < n; k++) {
        var nrm = 0;
        for (i = k; i < m; i++) {
            nrm = hypotenuse(nrm, qr[i][k]);
        }
        if (nrm !== 0) {
            if (qr[k][k] < 0) {
                nrm = -nrm;
            }
            for (i = k; i < m; i++) {
                qr[i][k] /= nrm;
            }
            qr[k][k] += 1;
            for (j = k + 1; j < n; j++) {
                s = 0;
                for (i = k; i < m; i++) {
                    s += qr[i][k] * qr[i][j];
                }
                s = -s / qr[k][k];
                for (i = k; i < m; i++) {
                    qr[i][j] += s * qr[i][k];
                }
            }
        }
        rdiag[k] = -nrm;
    }

    return new QrDecompositionResult(qr, rdiag);
}

function QrDecompositionResult(qr, rdiag) {
    this.QR = qr;
    this.Rdiag = rdiag;
}

QrDecompositionResult.prototype = {
    solve: function (value) {
        value = Matrix.checkMatrix(value);

        var qr = this.QR,
            m = qr.rows;

        if (value.rows !== m)
            throw new Error('Matrix row dimensions must agree');
        if (!this.isFullRank())
            throw new Error('Matrix is rank deficient');

        var count = value.columns,
            X = value.clone(),
            n = qr.columns,
            i, j, k, s;

        for (k = 0; k < n; k++) {
            for (j = 0; j < count; j++) {
                s = 0;
                for (i = k; i < m; i++) {
                    s += qr[i][k] * X[i][j];
                }
                s = -s / qr[k][k];
                for (i = k; i < m; i++) {
                    X[i][j] += s * qr[i][k];
                }
            }
        }
        for (k = n - 1; k >= 0; k--) {
            for (j = 0; j < count; j++) {
                X[k][j] /= this.Rdiag[k];
            }
            for (i = 0; i < k; i++) {
                for (j = 0; j < count; j++) {
                    X[i][j] -= X[k][j] * qr[i][k];
                }
            }
        }

        return X.subMatrix(0, n - 1, 0, count - 1);
    },
    isFullRank: function () {
        var columns = this.QR.columns;
        for (var i = 0; i < columns; i++) {
            if (this.Rdiag[i] === 0) {
                return false;
            }
        }
        return true;
    },
    get upperTriangularFactor() {
        var qr = this.QR,
            n = qr.columns,
            X = new Matrix(n, n),
            i, j;
        for (i = 0; i < n; i++) {
            for (j = 0; j < n; j++) {
                if (i < j) {
                    X[i][j] = qr[i][j];
                } else if (i === j) {
                    X[i][j] = this.Rdiag[i];
                } else {
                    X[i][j] = 0;
                }
            }
        }
        return X;
    },
    get orthogonalFactor() {
        var qr = this.QR,
            rows = qr.rows,
            columns = qr.columns,
            X = new Matrix(rows, columns),
            i, j, k, s;

        for (k = columns - 1; k >= 0; k--) {
            for (i = 0; i < rows; i++) {
                X[i][k] = 0;
            }
            X[k][k] = 1;
            for (j = k; j < columns; j++) {
                if (qr[k][k] !== 0) {
                    s = 0;
                    for (i = k; i < rows; i++) {
                        s += qr[i][k] * X[i][j];
                    }

                    s = -s / qr[k][k];

                    for (i = k; i < rows; i++) {
                        X[i][j] += s * qr[i][k];
                    }
                }
            }
        }
        return X;
    }
};

// https://github.com/lutzroeder/Mapack/blob/master/Source/SingularValueDecomposition.cs
function SingularValueDecomposition(value, options) {
    value = Matrix.checkMatrix(value);

    options = options || {};

    var a = value.clone(),
        m = value.rows,
        n = value.columns,
        nu = Math.min(m, n);

    var wantu = true, wantv = true;
    if (options.computeLeftSingularVectors === false)
        wantu = false;
    if (options.computeRightSingularVectors === false)
        wantv = false;
    var autoTranspose = options.autoTranspose === true;

    var swapped = false;
    if (m < n) {
        if (!autoTranspose) {
            console.warn('WARNING: Computing SVD on a matrix with more columns than rows.');
        } else {
            a = a.transpose();
            m = a.rows;
            n = a.columns;
            swapped = true;
            var aux = wantu;
            wantu = wantv;
            wantv = aux;
        }
    }

    var s = new Array(Math.min(m + 1, n)),
        U = Matrix.zeros(m, nu),
        V = Matrix.zeros(n, n),
        e = new Array(n),
        work = new Array(m);

    var nct = Math.min(m - 1, n);
    var nrt = Math.max(0, Math.min(n - 2, m));

    var i, j, k, p, t, ks, f, cs, sn, max, kase,
        scale, sp, spm1, epm1, sk, ek, b, c, shift, g;

    for (k = 0, max = Math.max(nct, nrt); k < max; k++) {
        if (k < nct) {
            s[k] = 0;
            for (i = k; i < m; i++) {
                s[k] = hypotenuse(s[k], a[i][k]);
            }
            if (s[k] !== 0) {
                if (a[k][k] < 0) {
                    s[k] = -s[k];
                }
                for (i = k; i < m; i++) {
                    a[i][k] /= s[k];
                }
                a[k][k] += 1;
            }
            s[k] = -s[k];
        }

        for (j = k + 1; j < n; j++) {
            if ((k < nct) && (s[k] !== 0)) {
                t = 0;
                for (i = k; i < m; i++) {
                    t += a[i][k] * a[i][j];
                }
                t = -t / a[k][k];
                for (i = k; i < m; i++) {
                    a[i][j] += t * a[i][k];
                }
            }
            e[j] = a[k][j];
        }

        if (wantu && (k < nct)) {
            for (i = k; i < m; i++) {
                U[i][k] = a[i][k];
            }
        }

        if (k < nrt) {
            e[k] = 0;
            for (i = k + 1; i < n; i++) {
                e[k] = hypotenuse(e[k], e[i]);
            }
            if (e[k] !== 0) {
                if (e[k + 1] < 0)
                    e[k] = -e[k];
                for (i = k + 1; i < n; i++) {
                    e[i] /= e[k];
                }
                e[k + 1] += 1;
            }
            e[k] = -e[k];
            if ((k + 1 < m) && (e[k] !== 0)) {
                for (i = k + 1; i < m; i++) {
                    work[i] = 0;
                }
                for (j = k + 1; j < n; j++) {
                    for (i = k + 1; i < m; i++) {
                        work[i] += e[j] * a[i][j];
                    }
                }
                for (j = k + 1; j < n; j++) {
                    t = -e[j] / e[k + 1];
                    for (i = k + 1; i < m; i++) {
                        a[i][j] += t * work[i];
                    }
                }
            }
            if (wantv) {
                for (i = k + 1; i < n; i++) {
                    V[i][k] = e[i];
                }
            }
        }
    }

    p = Math.min(n, m + 1);
    if (nct < n) {
        s[nct] = a[nct][nct];
    }
    if (m < p) {
        s[p - 1] = 0;
    }
    if (nrt + 1 < p) {
        e[nrt] = a[nrt][p - 1];
    }
    e[p - 1] = 0;

    if (wantu) {
        for (j = nct; j < nu; j++) {
            for (i = 0; i < m; i++) {
                U[i][j] = 0;
            }
            U[j][j] = 1;
        }
        for (k = nct - 1; k >= 0; k--) {
            if (s[k] !== 0) {
                for (j = k + 1; j < nu; j++) {
                    t = 0;
                    for (i = k; i < m; i++) {
                        t += U[i][k] * U[i][j];
                    }
                    t = -t / U[k][k];
                    for (i = k; i < m; i++) {
                        U[i][j] += t * U[i][k];
                    }
                }
                for (i = k; i < m; i++) {
                    U[i][k] = -U[i][k];
                }
                U[k][k] = 1 + U[k][k];
                for (i = 0; i < k - 1; i++) {
                    U[i][k] = 0;
                }
            } else {
                for (i = 0; i < m; i++) {
                    U[i][k] = 0;
                }
                U[k][k] = 1;
            }
        }
    }

    if (wantv) {
        for (k = n - 1; k >= 0; k--) {
            if ((k < nrt) && (e[k] !== 0)) {
                for (j = k + 1; j < n; j++) {
                    t = 0;
                    for (i = k + 1; i < n; i++) {
                        t += V[i][k] * V[i][j];
                    }
                    t = -t / V[k + 1][k];
                    for (i = k + 1; i < n; i++) {
                        V[i][j] += t * V[i][k];
                    }
                }
            }
            for (i = 0; i < n; i++) {
                V[i][k] = 0;
            }
            V[k][k] = 1;
        }
    }

    var pp = p - 1,
        iter = 0,
        eps = Math.pow(2, -52);
    while (p > 0) {
        for (k = p - 2; k >= -1; k--) {
            if (k === -1) {
                break;
            }
            if (Math.abs(e[k]) <= eps * (Math.abs(s[k]) + Math.abs(s[k + 1]))) {
                e[k] = 0;
                break;
            }
        }
        if (k === p - 2) {
            kase = 4;
        } else {
            for (ks = p - 1; ks >= k; ks--) {
                if (ks === k) {
                    break;
                }
                t = (ks !== p ? Math.abs(e[ks]) : 0) + (ks !== k + 1 ? Math.abs(e[ks - 1]) : 0);
                if (Math.abs(s[ks]) <= eps * t) {
                    s[ks] = 0;
                    break;
                }
            }
            if (ks === k) {
                kase = 3;
            } else if (ks === p - 1) {
                kase = 1;
            } else {
                kase = 2;
                k = ks;
            }
        }

        k++;

        switch (kase) {
            case 1: {
                f = e[p - 2];
                e[p - 2] = 0;
                for (j = p - 2; j >= k; j--) {
                    t = hypotenuse(s[j], f);
                    cs = s[j] / t;
                    sn = f / t;
                    s[j] = t;
                    if (j !== k) {
                        f = -sn * e[j - 1];
                        e[j - 1] = cs * e[j - 1];
                    }
                    if (wantv) {
                        for (i = 0; i < n; i++) {
                            t = cs * V[i][j] + sn * V[i][p - 1];
                            V[i][p - 1] = -sn * V[i][j] + cs * V[i][p - 1];
                            V[i][j] = t;
                        }
                    }
                }
                break;
            }
            case 2 : {
                f = e[k - 1];
                e[k - 1] = 0;
                for (j = k; j < p; j++) {
                    t = hypotenuse(s[j], f);
                    cs = s[j] / t;
                    sn = f / t;
                    s[j] = t;
                    f = -sn * e[j];
                    e[j] = cs * e[j];
                    if (wantu) {
                        for (i = 0; i < m; i++) {
                            t = cs * U[i][j] + sn * U[i][k - 1];
                            U[i][k - 1] = -sn * U[i][j] + cs * U[i][k - 1];
                            U[i][j] = t;
                        }
                    }
                }
                break;
            }
            case 3 : {
                scale = Math.max(Math.max(Math.max(Math.max(Math.abs(s[p - 1]), Math.abs(s[p - 2])), Math.abs(e[p - 2])), Math.abs(s[k])), Math.abs(e[k]));
                sp = s[p - 1] / scale;
                spm1 = s[p - 2] / scale;
                epm1 = e[p - 2] / scale;
                sk = s[k] / scale;
                ek = e[k] / scale;
                b = ((spm1 + sp) * (spm1 - sp) + epm1 * epm1) / 2;
                c = (sp * epm1) * (sp * epm1);
                shift = 0;
                if ((b !== 0) || (c !== 0)) {
                    shift = Math.sqrt(b * b + c);
                    if (b < 0) {
                        shift = -shift;
                    }
                    shift = c / (b + shift);
                }
                f = (sk + sp) * (sk - sp) + shift;
                g = sk * ek;
                for (j = k; j < p - 1; j++) {
                    t = hypotenuse(f, g);
                    cs = f / t;
                    sn = g / t;
                    if (j !== k) {
                        e[j - 1] = t;
                    }
                    f = cs * s[j] + sn * e[j];
                    e[j] = cs * e[j] - sn * s[j];
                    g = sn * s[j + 1];
                    s[j + 1] = cs * s[j + 1];
                    if (wantv) {
                        for (i = 0; i < n; i++) {
                            t = cs * V[i][j] + sn * V[i][j + 1];
                            V[i][j + 1] = -sn * V[i][j] + cs * V[i][j + 1];
                            V[i][j] = t;
                        }
                    }
                    t = hypotenuse(f, g);
                    cs = f / t;
                    sn = g / t;
                    s[j] = t;
                    f = cs * e[j] + sn * s[j + 1];
                    s[j + 1] = -sn * e[j] + cs * s[j + 1];
                    g = sn * e[j + 1];
                    e[j + 1] = cs * e[j + 1];
                    if (wantu && (j < m - 1)) {
                        for (i = 0; i < m; i++) {
                            t = cs * U[i][j] + sn * U[i][j + 1];
                            U[i][j + 1] = -sn * U[i][j] + cs * U[i][j + 1];
                            U[i][j] = t;
                        }
                    }
                }
                e[p - 2] = f;
                iter = iter + 1;
                break;
            }
            case 4: {
                if (s[k] <= 0) {
                    s[k] = (s[k] < 0 ? -s[k] : 0);
                    if (wantv) {
                        for (i = 0; i <= pp; i++) {
                            V[i][k] = -V[i][k];
                        }
                    }
                }
                while (k < pp) {
                    if (s[k] >= s[k + 1]) {
                        break;
                    }
                    t = s[k];
                    s[k] = s[k + 1];
                    s[k + 1] = t;
                    if (wantv && (k < n - 1)) {
                        for (i = 0; i < n; i++) {
                            t = V[i][k + 1];
                            V[i][k + 1] = V[i][k];
                            V[i][k] = t;
                        }
                    }
                    if (wantu && (k < m - 1)) {
                        for (i = 0; i < m; i++) {
                            t = U[i][k + 1];
                            U[i][k + 1] = U[i][k];
                            U[i][k] = t;
                        }
                    }
                    k++;
                }
                iter = 0;
                p--;
                break;
            }
        }
    }

    if (swapped) {
        var tmp = V;
        V = U;
        U = tmp;
    }

    return new SingularValueDecompositionResult(m, n, s, U, V);
}

function SingularValueDecompositionResult(m, n, s, U, V) {
    this.m = m;
    this.n = n;
    this.s = s;
    this.U = U;
    this.V = V;
}

SingularValueDecompositionResult.prototype = {
    get condition() {
        return this.s[0] / this.s[Math.min(this.m, this.n) - 1];
    },
    get norm2() {
        return this.s[0];
    },
    get rank() {
        var eps = Math.pow(2, -52),
            tol = Math.max(this.m, this.n) * this.s[0] * eps,
            r = 0,
            s = this.s;
        for (var i = 0, ii = s.length; i < ii; i++) {
            if (s[i] > tol) {
                r++;
            }
        }
        return r;
    },
    get diagonal() {
        return this.s;
    },
    // https://github.com/accord-net/framework/blob/development/Sources/Accord.Math/Decompositions/SingularValueDecomposition.cs
    get threshold() {
        return (Math.pow(2, -52) / 2) * Math.max(this.m, this.n) * this.s[0];
    },
    get leftSingularVectors() {
        return this.U;
    },
    get rightSingularVectors() {
        return this.V;
    },
    get diagonalMatrix() {
        return Matrix.diag(this.s);
    },
    solve: function (value) {

        var Y = value,
            e = this.threshold,
            scols = this.s.length,
            Ls = Matrix.zeros(scols, scols),
            i;

        for (i = 0; i < scols; i++) {
            if (Math.abs(this.s[i]) <= e) {
                Ls[i][i] = 0;
            }
            else Ls[i][i] = 1 / this.s[i];
        }


        var VL = this.V.mmul(Ls),
            vrows = this.V.rows,
            urows = this.U.rows,
            VLU = Matrix.zeros(vrows, urows),
            j, k, sum;

        for (i = 0; i < vrows; i++) {
            for (j = 0; j < urows; j++) {
                sum = 0;
                for (k = 0; k < scols; k++) {
                    sum += VL[i][k] * this.U[j][k];
                }
                VLU[i][j] = sum;
            }
        }

        return VLU.mmul(Y);
    },
    solveForDiagonal: function (value) {
        return this.solve(Matrix.diag(value));
    },
    inverse: function () {
        var e = this.threshold,
            vrows = this.V.rows,
            vcols = this.V.columns,
            X = new Matrix(vrows, this.s.length),
            i, j;

        for (i = 0; i < vrows; i++) {
            for (j = 0; j < vcols; j++) {
                if (Math.abs(this.s[j]) > e) {
                    X[i][j] = this.V[i][j] / this.s[j];
                }
            }
        }

        var urows = this.U.rows,
            ucols = this.U.columns,
            Y = new Matrix(vrows, urows),
            k, sum;

        for (i = 0; i < vrows; i++) {
            for (j = 0; j < urows; j++) {
                sum = 0;
                for (k = 0; k < ucols; k++) {
                    sum += X[i][k] * this.U[j][k];
                }
                Y[i][j] = sum;
            }
        }

        return Y;
    }
};

// https://github.com/lutzroeder/Mapack/blob/master/Source/CholeskyDecomposition.cs
function CholeskyDecomposition(value) {
    value = Matrix.checkMatrix(value);
    if (!value.isSymmetric())
        throw new Error('Matrix is not symmetric');

    var a = value,
        dimension = a.rows,
        l = new Matrix(dimension, dimension),
        positiveDefinite = true,
        i, j, k;

    for (j = 0; j < dimension; j++) {
        var Lrowj = l[j];
        var d = 0;
        for (k = 0; k < j; k++) {
            var Lrowk = l[k];
            var s = 0;
            for (i = 0; i < k; i++) {
                s += Lrowk[i] * Lrowj[i];
            }
            Lrowj[k] = s = (a[j][k] - s) / l[k][k];
            d = d + s * s;
        }

        d = a[j][j] - d;

        positiveDefinite &= (d > 0);
        l[j][j] = Math.sqrt(Math.max(d, 0));
        for (k = j + 1; k < dimension; k++) {
            l[j][k] = 0;
        }
    }

    if (!positiveDefinite) {
        throw new Error('Matrix is not positive definite');
    }

    return new CholeskyDecompositionResult(l);
}

function CholeskyDecompositionResult(l) {
    this.L = l;
}

CholeskyDecompositionResult.prototype = {
    get leftTriangularFactor() {
        return this.L;
    },
    solve: function (value) {
        value = Matrix.checkMatrix(value);

        var l = this.L,
            dimension = l.rows;

        if (value.rows !== dimension) {
            throw new Error('Matrix dimensions do not match');
        }

        var count = value.columns,
            B = value.clone(),
            i, j, k;

        for (k = 0; k < dimension; k++) {
            for (j = 0; j < count; j++) {
                for (i = 0; i < k; i++) {
                    B[k][j] -= B[i][j] * l[k][i];
                }
                B[k][j] /= l[k][k];
            }
        }

        for (k = dimension - 1; k >= 0; k--) {
            for (j = 0; j < count; j++) {
                for (i = k + 1; i < dimension; i++) {
                    B[k][j] -= B[i][j] * l[i][k];
                }
                B[k][j] /= l[k][k];
            }
        }

        return B;
    }
};

function hypotenuse(a, b) {
    var r;
    if (Math.abs(a) > Math.abs(b)) {
        r = b / a;
        return Math.abs(a) * Math.sqrt(1 + r * r);
    }
    if (b !== 0) {
        r = a / b;
        return Math.abs(b) * Math.sqrt(1 + r * r);
    }
    return 0;
}

function inverse(matrix) {
    return solve(matrix, Matrix.eye(matrix.rows));
}

Matrix.prototype.inverse = function () {
    return inverse(this);
};

function solve(leftHandSide, rightHandSide) {
    return leftHandSide.isSquare() ? new LuDecomposition(leftHandSide).solve(rightHandSide) : new QrDecomposition(leftHandSide).solve(rightHandSide);
}

Matrix.prototype.solve = function (other) {
    return solve(this, other);
};

module.exports = {
    LuDecomposition: LuDecomposition,
    LU: LuDecomposition,
    QrDecomposition: QrDecomposition,
    QR: QrDecomposition,
    SingularValueDecomposition: SingularValueDecomposition,
    SVD: SingularValueDecomposition,
    EigenvalueDecomposition: EigenvalueDecomposition,
    EVD: EigenvalueDecomposition,
    CholeskyDecomposition: CholeskyDecomposition,
    CHO: CholeskyDecomposition,
    inverse: inverse,
    solve: solve
};

},{"./matrix":5}],4:[function(require,module,exports){
'use strict';

module.exports = require('./matrix');
module.exports.Decompositions = module.exports.DC = require('./decompositions');
},{"./decompositions":3,"./matrix":5}],5:[function(require,module,exports){
'use strict';

var Asplice = Array.prototype.splice,
    Aconcat = Array.prototype.concat;

// For performance : http://jsperf.com/clone-array-slice-vs-while-vs-for
function slice(arr) {
    var i = 0,
        ii = arr.length,
        result = new Array(ii);
    for (; i < ii; i++) {
        result[i] = arr[i];
    }
    return result;
}

function MatrixError(message) {
    this.message = message || 'Unknown matrix error';
}
MatrixError.prototype = Object.create(Error.prototype);
MatrixError.prototype.name = 'MatrixError';
MatrixError.prototype.constructor = MatrixError;

/**
 * Real matrix.
 * @constructor
 * @param {number|Array} nRows - Number of rows of the new matrix or a 2D array containing the data.
 * @param {number|boolean} [nColumns] - Number of columns of the new matrix or a boolean specifying if the input array should be cloned
 */
function Matrix(nRows, nColumns) {
    var i = 0, rows, columns, matrix, newInstance;
    if (nRows instanceof Array) {
        newInstance = nColumns;
        matrix = newInstance ? slice(nRows) : nRows;
        nRows = matrix.length;
        nColumns = matrix[0].length;
        if (typeof nColumns === 'undefined') {
            throw new MatrixError('Data must be a 2D array');
        }
        if (nRows > 0 && nColumns > 0) {
            for (; i < nRows; i++) {
                if (matrix[i].length !== nColumns) {
                    throw new MatrixError('Inconsistent array dimensions');
                } else if (newInstance) {
                    matrix[i] = slice(matrix[i]);
                }
            }
        } else {
            throw new MatrixError('Invalid dimensions: ' + nRows + 'x' + nColumns);
        }
    } else if (typeof nRows === 'number') { // Create empty matrix
        if (nRows > 0 && nColumns > 0) {
            matrix = new Array(nRows);
            for (; i < nRows; i++) {
                matrix[i] = new Array(nColumns);
            }
        } else {
            throw new MatrixError('Invalid dimensions: ' + nRows + 'x' + nColumns);
        }
    } else {
        throw new MatrixError('Invalid arguments')
    }

    Object.defineProperty(matrix, 'rows', {writable: true, value: nRows});
    Object.defineProperty(matrix, 'columns', {writable: true, value: nColumns});

    matrix.__proto__ = Matrix.prototype;

    return matrix;
}

/**
 * Constructs a Matrix with the chosen dimensions from a 1D array.
 * @param {number} newRows - Number of rows
 * @param {number} newColumns - Number of columns
 * @param {Array} newData - A 1D array containing data for the matrix
 * @returns {Matrix} - The new matrix
 */
Matrix.from1DArray = function from1DArray(newRows, newColumns, newData) {
    var length, data, i = 0;

    length = newRows * newColumns;
    if (length !== newData.length)
        throw new MatrixError('Data length does not match given dimensions');

    data = new Array(newRows);
    for (; i < newRows; i++) {
        data[i] = newData.slice(i * newColumns, (i + 1) * newColumns);
    }
    return new Matrix(data);
};

/**
 * Creates a row vector, a matrix with only one row.
 * @param {Array} newData - A 1D array containing data for the vector
 * @returns {Matrix} - The new matrix
 */
Matrix.rowVector = function rowVector(newData) {
    return new Matrix([newData]);
};

/**
 * Creates a column vector, a matrix with only one column.
 * @param {Array} newData - A 1D array containing data for the vector
 * @returns {Matrix} - The new matrix
 */
Matrix.columnVector = function columnVector(newData) {
    var l = newData.length, vector = new Array(l);
    for (var i = 0; i < l; i++)
        vector[i] = [newData[i]];
    return new Matrix(vector);
};

/**
 * Creates an empty matrix with the given dimensions. Values will be undefined. Same as using new Matrix(rows, columns).
 * @param {number} rows - Number of rows
 * @param {number} columns - Number of columns
 * @returns {Matrix} - The new matrix
 */
Matrix.empty = function empty(rows, columns) {
    return new Matrix(rows, columns);
};

/**
 * Creates a matrix with the given dimensions. Values will be set to zero.
 * @param {number} rows - Number of rows
 * @param {number} columns - Number of columns
 * @returns {Matrix} - The new matrix
 */
Matrix.zeros = function zeros(rows, columns) {
    return Matrix.empty(rows, columns).fill(0);
};

/**
 * Creates a matrix with the given dimensions. Values will be set to one.
 * @param {number} rows - Number of rows
 * @param {number} columns - Number of columns
 * @returns {Matrix} - The new matrix
 */
Matrix.ones = function ones(rows, columns) {
    return Matrix.empty(rows, columns).fill(1);
};

/**
 * Creates a matrix with the given dimensions. Values will be randomly set using Math.random().
 * @param {number} rows - Number of rows
 * @param {number} columns - Number of columns
 * @returns {Matrix} The new matrix
 */
Matrix.rand = function rand(rows, columns) {
    var matrix = Matrix.empty(rows, columns);
    for (var i = 0, ii = matrix.rows; i < ii; i++) {
        for (var j = 0, jj = matrix.columns; j < jj; j++) {
            matrix[i][j] = Math.random();
        }
    }
    return matrix;
};

/**
 * Creates an identity matrix with the given dimension. Values of the diagonal will be 1 and other will be 0.
 * @param {number} n - Number of rows and columns
 * @returns {Matrix} - The new matrix
 */
Matrix.eye = function eye(n) {
    var matrix = Matrix.zeros(n, n), l = matrix.rows;
    for (var i = 0; i < l; i++) {
        matrix[i][i] = 1;
    }
    return matrix;
};

/**
 * Creates a diagonal matrix based on the given array.
 * @param {Array} data - Array containing the data for the diagonal
 * @returns {Matrix} - The new matrix
 */
Matrix.diag = function diag(data) {
    var l = data.length, matrix = Matrix.zeros(l, l);
    for (var i = 0; i < l; i++) {
        matrix[i][i] = data[i];
    }
    return matrix;
};

/**
 * Creates an array of indices between two values
 * @param {number} from
 * @param {number} to
 * @returns {Array}
 */
Matrix.indices = function indices(from, to) {
    var vector = new Array(to - from);
    for (var i = 0; i < vector.length; i++)
        vector[i] = from++;
    return vector;
};

// TODO DOC
Matrix.stack = function stack(arg1) {
    var i, j, k;
    if (Matrix.isMatrix(arg1)) {
        var rows = 0,
            cols = 0;
        for (i = 0; i < arguments.length; i++) {
            rows += arguments[i].rows;
            if (arguments[i].columns > cols)
                cols = arguments[i].columns;
        }

        var r = Matrix.zeros(rows, cols);
        var c = 0;
        for (i = 0; i < arguments.length; i++) {
            var current = arguments[i];
            for (j = 0; j < current.rows; j++) {
                for (k = 0; k < current.columns; k++)
                    r[c][k] = current[j][k];
                c++;
            }
        }
        return r;
    }
    else if (arg1 instanceof Array) {
        var matrix = Matrix.empty(arguments.length, arg1.length);
        for (i = 0; i < arguments.length; i++)
            matrix.setRow(i, arguments[i]);
        return matrix;
    }
};

// TODO DOC
Matrix.expand = function expand(base, count) {
    var expansion = [];
    for (var i = 0; i < count.length; i++)
        for (var j = 0; j < count[i]; j++)
            expansion.push(base[i]);
    return new Matrix(expansion);
};

/**
 * Check that the provided value is a Matrix and tries to instantiate one if not
 * @param value - The value to check
 * @returns {Matrix}
 * @throws {MatrixError}
 */
Matrix.checkMatrix = function checkMatrix(value) {
    if (!value) {
        throw new MatrixError('Argument has to be a matrix');
    }
    if (value.klass !== 'Matrix') {
        value = new Matrix(value);
    }
    return value;
};

/**
 * Returns true if the argument is a Matrix, false otherwise
 * @param value - The value to check
 * @returns {boolean}
 */
Matrix.isMatrix = function isMatrix(value) {
    return value ? value.klass === 'Matrix' : false;
};

/**
 * @property {string} - The name of this class.
 */
Object.defineProperty(Matrix.prototype, 'klass', {
    get: function klass() {
        return 'Matrix';
    }
});

/**
 * @property {number} - The number of elements in the matrix.
 */
Object.defineProperty(Matrix.prototype, 'size', {
    get: function size() {
        return this.rows * this.columns;
    }
});

/**
 * @private
 * Internal check that a row index is not out of bounds
 * @param {number} index
 */
Matrix.prototype.checkRowIndex = function checkRowIndex(index) {
    if (index < 0 || index > this.rows - 1)
        throw new MatrixError('Row index out of range.');
};

/**
 * @private
 * Internal check that a column index is not out of bounds
 * @param {number} index
 */
Matrix.prototype.checkColumnIndex = function checkColumnIndex(index) {
    if (index < 0 || index > this.columns - 1)
        throw new MatrixError('Column index out of range.');
};

/**
 * @private
 * Internal check that two matrices have the same dimensions
 * @param {Matrix} otherMatrix
 */
Matrix.prototype.checkDimensions = function checkDimensions(otherMatrix) {
    if ((this.rows !== otherMatrix.rows) || (this.columns !== otherMatrix.columns))
        throw new MatrixError('Matrices dimensions must be equal.');
};

/**
 * Applies a callback for each element of the matrix. The function is called in the matrix (this) context.
 * @param {function} callback - Function that will be called with two parameters : i (row) and j (column)
 * @returns {Matrix} this
 */
Matrix.prototype.apply = function apply(callback) {
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            callback.call(this, i, j);
        }
    }
    return this;
};

/**
 * Creates an exact and independent copy of the matrix
 * @returns {Matrix}
 */
Matrix.prototype.clone = function clone() {
    return new Matrix(this.to2DArray());
};

/**
 * Returns a new 1D array filled row by row with the matrix values
 * @returns {Array}
 */
Matrix.prototype.to1DArray = function to1DArray() {
    return Aconcat.apply([], this);
};

/**
 * Returns a 2D array containing a copy of the data
 * @returns {Array}
 */
Matrix.prototype.to2DArray = function to2DArray() {
    var l = this.rows, copy = new Array(l);
    for (var i = 0; i < l; i++) {
        copy[i] = slice(this[i]);
    }
    return copy;
};

/**
 * @returns {boolean} true if the matrix has one row
 */
Matrix.prototype.isRowVector = function isRowVector() {
    return this.rows === 1;
};

/**
 * @returns {boolean} true if the matrix has one column
 */
Matrix.prototype.isColumnVector = function isColumnVector() {
    return this.columns === 1;
};

/**
 * @returns {boolean} true if the matrix has one row or one column
 */
Matrix.prototype.isVector = function isVector() {
    return (this.rows === 1) || (this.columns === 1);
};

/**
 * @returns {boolean} true if the matrix has the same number of rows and columns
 */
Matrix.prototype.isSquare = function isSquare() {
    return this.rows === this.columns;
};

/**
 * @returns {boolean} true if the matrix is square and has the same values on both sides of the diagonal
 */
Matrix.prototype.isSymmetric = function isSymmetric() {
    if (this.isSquare()) {
        var l = this.rows;
        for (var i = 0; i < l; i++) {
            for (var j = 0; j <= i; j++) {
                if (this[i][j] !== this[j][i]) {
                    return false;
                }
            }
        }
        return true;
    }
    return false;
};

/**
 * Sets a given element of the matrix. mat.set(3,4,1) is equivalent to mat[3][4]=1
 * @param {number} rowIndex - Index of the row
 * @param {number} columnIndex - Index of the column
 * @param {number} value - The new value for the element
 * @returns {Matrix} this
 */
Matrix.prototype.set = function set(rowIndex, columnIndex, value) {
    this[rowIndex][columnIndex] = value;
    return this;
};

/**
 * Returns the given element of the matrix. mat.get(3,4) is equivalent to matrix[3][4]
 * @param {number} rowIndex - Index of the row
 * @param {number} columnIndex - Index of the column
 * @returns {number}
 */
Matrix.prototype.get = function get(rowIndex, columnIndex) {
    return this[rowIndex][columnIndex];
};

/**
 * Fills the matrix with a given value. All elements will be set to this value.
 * @param {number} value - New value
 * @returns {Matrix} this
 */
Matrix.prototype.fill = function fill(value) {
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] = value;
        }
    }
    return this;
};

/**
 * Negates the matrix. All elements will be multiplied by (-1)
 * @returns {Matrix} this
 */
Matrix.prototype.neg = function neg() {
    return this.mulS(-1);
};

/**
 * Adds a scalar or values from another matrix (in place)
 * @param {number|Matrix} value
 * @returns {Matrix} this
 */
Matrix.prototype.add = function add(value) {
    if (typeof value === 'number')
        return this.addS(value);
    value = Matrix.checkMatrix(value);
        return this.addM(value);
};

/**
 * Adds a scalar to each element of the matrix
 * @param {number} value
 * @returns {Matrix} this
 */
Matrix.prototype.addS = function addS(value) {
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] += value;
        }
    }
    return this;
};

/**
 * Adds the value of each element of matrix to the corresponding element of this
 * @param {Matrix} matrix
 * @returns {Matrix} this
 */
Matrix.prototype.addM = function addM(matrix) {
    this.checkDimensions(matrix);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] += matrix[i][j];
        }
    }
    return this;
};

/**
 * Subtracts a scalar or values from another matrix (in place)
 * @param {number|Matrix} value
 * @returns {Matrix} this
 */
Matrix.prototype.sub = function sub(value) {
    if (typeof value === 'number')
        return this.subS(value);
    value = Matrix.checkMatrix(value);
        return this.subM(value);
};

/**
 * Subtracts a scalar from each element of the matrix
 * @param {number} value
 * @returns {Matrix} this
 */
Matrix.prototype.subS = function subS(value) {
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] -= value;
        }
    }
    return this;
};

/**
 * Subtracts the value of each element of matrix from the corresponding element of this
 * @param {Matrix} matrix
 * @returns {Matrix} this
 */
Matrix.prototype.subM = function subM(matrix) {
    this.checkDimensions(matrix);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] -= matrix[i][j];
        }
    }
    return this;
};

/**
 * Multiplies a scalar or values from another matrix (in place)
 * @param {number|Matrix} value
 * @returns {Matrix} this
 */
Matrix.prototype.mul = function mul(value) {
    if (typeof value === 'number')
        return this.mulS(value);
    value = Matrix.checkMatrix(value);
        return this.mulM(value);
};

/**
 * Multiplies a scalar with each element of the matrix
 * @param {number} value
 * @returns {Matrix} this
 */
Matrix.prototype.mulS = function mulS(value) {
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] *= value;
        }
    }
    return this;
};

/**
 * Multiplies the value of each element of matrix with the corresponding element of this
 * @param {Matrix} matrix
 * @returns {Matrix} this
 */
Matrix.prototype.mulM = function mulM(matrix) {
    this.checkDimensions(matrix);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] *= matrix[i][j];
        }
    }
    return this;
};

/**
 * Divides by a scalar or values from another matrix (in place)
 * @param {number|Matrix} value
 * @returns {Matrix} this
 */
Matrix.prototype.div = function div(value) {
    if (typeof value === 'number')
        return this.divS(value);
    value = Matrix.checkMatrix(value);
        return this.divM(value);
};

/**
 * Divides each element of the matrix by a scalar
 * @param {number} value
 * @returns {Matrix} this
 */
Matrix.prototype.divS = function divS(value) {
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] /= value;
        }
    }
    return this;
};

/**
 * Divides each element of this by the corresponding element of matrix
 * @param {Matrix} matrix
 * @returns {Matrix} this
 */
Matrix.prototype.divM = function divM(matrix) {
    this.checkDimensions(matrix);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] /= matrix[i][j];
        }
    }
    return this;
};

/**
 * Returns a new array from the given row index
 * @param {number} index - Row index
 * @returns {Array}
 */
Matrix.prototype.getRow = function getRow(index) {
    this.checkRowIndex(index);
    return slice(this[index]);
};

/**
 * Sets a row at the given index
 * @param {number} index - Row index
 * @param {Array|Matrix} array - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.setRow = function setRow(index, array) {
    this.checkRowIndex(index);
    if (Matrix.isMatrix(array)) array = array.to1DArray();
    if (array.length !== this.columns)
        throw new MatrixError('Invalid row size');
    this[index] = slice(array);
    return this;
};

/**
 * Removes a row from the given index
 * @param {number} index - Row index
 * @returns {Matrix} this
 */
Matrix.prototype.removeRow = function removeRow(index) {
    this.checkRowIndex(index);
    if (this.rows === 1)
        throw new MatrixError('A matrix cannot have less than one row');
    Asplice.call(this, index, 1);
    this.rows -= 1;
    return this;
};

/**
 * Adds a row at the given index
 * @param {number} [index = this.rows] - Row index
 * @param {Array|Matrix} array - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.addRow = function addRow(index, array) {
    if (typeof array === 'undefined') {
        array = index;
        index = this.rows;
    }
    if (index < 0 || index > this.rows)
        throw new MatrixError('Row index out of range.');
    if (Matrix.isMatrix(array)) array = array.to1DArray();
    if (array.length !== this.columns)
        throw new MatrixError('Invalid row size');
    Asplice.call(this, index, 0, slice(array));
    this.rows += 1;
    return this;
};

/**
 * Swaps two rows
 * @param {number} row1 - First row index
 * @param {number} row2 - Second row index
 * @returns {Matrix} this
 */
Matrix.prototype.swapRows = function swapRows(row1, row2) {
    this.checkRowIndex(row1);
    this.checkRowIndex(row2);
    var temp = this[row1];
    this[row1] = this[row2];
    this[row2] = temp;
    return this;
};

/**
 * Returns a new array from the given column index
 * @param {number} index - Column index
 * @returns {Array}
 */
Matrix.prototype.getColumn = function getColumn(index) {
    this.checkColumnIndex(index);
    var l = this.rows, column = new Array(l);
    for (var i = 0; i < l; i++) {
        column[i] = this[i][index];
    }
    return column;
};

/**
 * Sets a column at the given index
 * @param {number} index - Column index
 * @param {Array|Matrix} array - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.setColumn = function setColumn(index, array) {
    this.checkColumnIndex(index);
    if (Matrix.isMatrix(array)) array = array.to1DArray();
    var l = this.rows;
    if (array.length !== l)
        throw new MatrixError('Invalid column size');
    for (var i = 0; i < l; i++) {
        this[i][index] = array[i];
    }
    return this;
};

/**
 * Removes a column from the given index
 * @param {number} index - Column index
 * @returns {Matrix} this
 */
Matrix.prototype.removeColumn = function removeColumn(index) {
    this.checkColumnIndex(index);
    if (this.columns === 1)
        throw new MatrixError('A matrix cannot have less than one column');
    for (var i = 0, ii = this.rows; i < ii; i++) {
        this[i].splice(index, 1);
    }
    this.columns -= 1;
    return this;
};

/**
 * Adds a column at the given index
 * @param {number} [index = this.columns] - Column index
 * @param {Array|Matrix} array - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.addColumn = function addColumn(index, array) {
    if (typeof array === 'undefined') {
        array = index;
        index = this.columns;
    }
    if (index < 0 || index > this.columns)
        throw new MatrixError('Column index out of range.');
    if (Matrix.isMatrix(array)) array = array.to1DArray();
    var l = this.rows;
    if (array.length !== l)
        throw new MatrixError('Invalid column size');
    for (var i = 0; i < l; i++) {
        this[i].splice(index, 0, array[i]);
    }
    this.columns += 1;
    return this;
};

/**
 * Swaps two columns
 * @param {number} column1 - First column index
 * @param {number} column2 - Second column index
 * @returns {Matrix} this
 */
Matrix.prototype.swapColumns = function swapColumns(column1, column2) {
    this.checkRowIndex(column1);
    this.checkRowIndex(column2);
    var l = this.rows, temp, row;
    for (var i = 0; i < l; i++) {
        row = this[i];
        temp = row[column1];
        row[column1] = row[column2];
        row[column2] = temp;
    }
    return this;
};

/**
 * @private
 * Internal check that the provided vector is an array with the right length
 * @param {Array|Matrix} vector
 * @returns {Array}
 * @throws {MatrixError}
 */
Matrix.prototype.checkRowVector = function checkRowVector(vector) {
    if (Matrix.isMatrix(vector))
        vector = vector.to1DArray();
    if (vector.length !== this.columns)
        throw new MatrixError('vector size must be the same as the number of columns');
    return vector;
};

/**
 * @private
 * Internal check that the provided vector is an array with the right length
 * @param {Array|Matrix} vector
 * @returns {Array}
 * @throws {MatrixError}
 */
Matrix.prototype.checkColumnVector = function checkColumnVector(vector) {
    if (Matrix.isMatrix(vector))
        vector = vector.to1DArray();
    if (vector.length !== this.rows)
        throw new MatrixError('vector size must be the same as the number of rows');
    return vector;
};

/**
 * Adds the values of a vector to each row
 * @param {Array|Matrix} vector - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.addRowVector = function addRowVector(vector) {
    vector = this.checkRowVector(vector);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] += vector[j];
        }
    }
    return this;
};

/**
 * Subtracts the values of a vector from each row
 * @param {Array|Matrix} vector - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.subRowVector = function subRowVector(vector) {
    vector = this.checkRowVector(vector);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] -= vector[j];
        }
    }
    return this;
};

/**
 * Multiplies the values of a vector with each row
 * @param {Array|Matrix} vector - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.mulRowVector = function mulRowVector(vector) {
    vector = this.checkRowVector(vector);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] *= vector[j];
        }
    }
    return this;
};

/**
 * Divides the values of each row by those of a vector
 * @param {Array|Matrix} vector - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.divRowVector = function divRowVector(vector) {
    vector = this.checkRowVector(vector);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] /= vector[j];
        }
    }
    return this;
};

/**
 * Adds the values of a vector to each column
 * @param {Array|Matrix} vector - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.addColumnVector = function addColumnVector(vector) {
    vector = this.checkColumnVector(vector);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] += vector[i];
        }
    }
    return this;
};

/**
 * Subtracts the values of a vector from each column
 * @param {Array|Matrix} vector - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.subColumnVector = function subColumnVector(vector) {
    vector = this.checkColumnVector(vector);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] -= vector[i];
        }
    }
    return this;
};

/**
 * Multiplies the values of a vector with each column
 * @param {Array|Matrix} vector - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.mulColumnVector = function mulColumnVector(vector) {
    vector = this.checkColumnVector(vector);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] *= vector[i];
        }
    }
    return this;
};

/**
 * Divides the values of each column by those of a vector
 * @param {Array|Matrix} vector - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.divColumnVector = function divColumnVector(vector) {
    vector = this.checkColumnVector(vector);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] /= vector[i];
        }
    }
    return this;
};

/**
 * Multiplies the values of a row with a scalar
 * @param {number} index - Row index
 * @param {number} value
 * @returns {Matrix} this
 */
Matrix.prototype.mulRow = function mulRow(index, value) {
    this.checkRowIndex(index);
    var i = 0, l = this.columns;
    for (; i < l; i++) {
        this[index][i] *= value;
    }
    return this;
};

/**
 * Multiplies the values of a column with a scalar
 * @param {number} index - Column index
 * @param {number} value
 * @returns {Matrix} this
 */
Matrix.prototype.mulColumn = function mulColumn(index, value) {
    this.checkColumnIndex(index);
    var i = 0, l = this.rows;
    for (; i < l; i++) {
        this[i][index] *= value;
    }
};

/**
 * A matrix index
 * @typedef {Object} MatrixIndex
 * @property {number} row
 * @property {number} column
 */

/**
 * Returns the maximum value of the matrix
 * @returns {number}
 */
Matrix.prototype.max = function max() {
    var v = -Infinity;
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            if (this[i][j] > v) {
                v = this[i][j];
            }
        }
    }
    return v;
};

/**
 * Returns the index of the maximum value
 * @returns {MatrixIndex}
 */
Matrix.prototype.maxIndex = function maxIndex() {
    var v = -Infinity;
    var idx = {};
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            if (this[i][j] > v) {
                v = this[i][j];
                idx.row = i;
                idx.column = j;
            }
        }
    }
    return idx;
};

/**
 * Returns the minimum value of the matrix
 * @returns {number}
 */
Matrix.prototype.min = function min() {
    var v = Infinity;
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            if (this[i][j] < v) {
                v = this[i][j];
            }
        }
    }
    return v;
};

/**
 * Returns the index of the minimum value
 * @returns {MatrixIndex}
 */
Matrix.prototype.minIndex = function minIndex() {
    var v = Infinity;
    var idx = {};
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            if (this[i][j] < v) {
                v = this[i][j];
                idx.row = i;
                idx.column = j;
            }
        }
    }
    return idx;
};

/**
 * Returns the maximum value of one row
 * @param {number} index - Row index
 * @returns {number}
 */
Matrix.prototype.maxRow = function maxRow(index) {
    this.checkRowIndex(index);
    var v = -Infinity;
    for (var i = 0, ii = this.columns; i < ii; i++) {
        if (this[index][i] > v) {
            v = this[index][i];
        }
    }
    return v;
};

/**
 * Returns the index of the maximum value of one row
 * @param {number} index - Row index
 * @returns {MatrixIndex}
 */
Matrix.prototype.maxRowIndex = function maxRowIndex(index) {
    this.checkRowIndex(index);
    var v = -Infinity;
    var idx = {
            row: index
        };
    for (var i = 0, ii = this.columns; i < ii; i++) {
        if (this[index][i] > v) {
            v = this[index][i];
            idx.column = i;
        }
    }
    return idx;
};

/**
 * Returns the minimum value of one row
 * @param {number} index - Row index
 * @returns {number}
 */
Matrix.prototype.minRow = function minRow(index) {
    this.checkRowIndex(index);
    var v = Infinity;
    for (var i = 0, ii = this.columns; i < ii; i++) {
        if (this[index][i] < v) {
            v = this[index][i];
        }
    }
    return v;
};

/**
 * Returns the index of the maximum value of one row
 * @param {number} index - Row index
 * @returns {MatrixIndex}
 */
Matrix.prototype.minRowIndex = function minRowIndex(index) {
    this.checkRowIndex(index);
    var v = Infinity;
    var idx = {
        row: index,
        column: 0
    };
    for (var i = 0, ii = this.columns; i < ii; i++) {
        if (this[index][i] < v) {
            v = this[index][i];
            idx.column = i;
        }
    }
    return idx;
};

/**
 * Returns the maximum value of one column
 * @param {number} index - Column index
 * @returns {number}
 */
Matrix.prototype.maxColumn = function maxColumn(index) {
    this.checkColumnIndex(index);
    var v = -Infinity;
    for (var i = 0, ii = this.rows; i < ii; i++) {
        if (this[i][index] > v) {
            v = this[i][index];
        }
    }
    return v;
};

/**
 * Returns the index of the maximum value of one column
 * @param {number} index - Column index
 * @returns {MatrixIndex}
 */
Matrix.prototype.maxColumnIndex = function maxColumnIndex(index) {
    this.checkColumnIndex(index);
    var v = -Infinity;
    var idx = {
        row: 0,
        column: index
    };
    for (var i = 0, ii = this.rows; i < ii; i++) {
        if (this[i][index] > v) {
            v = this[i][index];
            idx.row = i;
        }
    }
    return idx;
};

/**
 * Returns the minimum value of one column
 * @param {number} index - Column index
 * @returns {number}
 */
Matrix.prototype.minColumn = function minColumn(index) {
    this.checkColumnIndex(index);
    var v = Infinity;
    for (var i = 0, ii = this.rows; i < ii; i++) {
        if (this[i][index] < v) {
            v = this[i][index];
        }
    }
    return v;
};

/**
 * Returns the index of the minimum value of one column
 * @param {number} index - Column index
 * @returns {MatrixIndex}
 */
Matrix.prototype.minColumnIndex = function minColumnIndex(index) {
    this.checkColumnIndex(index);
    var v = Infinity;
    var idx = {
        row: 0,
        column: index
    };
    for (var i = 0, ii = this.rows; i < ii; i++) {
        if (this[i][index] < v) {
            v = this[i][index];
            idx.row = i;
        }
    }
    return idx;
};

/**
 * Returns an array containing the diagonal values of the matrix
 * @returns {Array}
 */
Matrix.prototype.diag = function diag() {
    if (!this.isSquare())
        throw new MatrixError('Only square matrices have a diagonal.');
    var diag = new Array(this.rows);
    for (var i = 0, ii = this.rows; i < ii; i++) {
        diag[i] = this[i][i];
    }
    return diag;
};

/**
 * Returns the sum of all elements of the matrix
 * @returns {number}
 */
Matrix.prototype.sum = function sum() {
    var v = 0;
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            v += this[i][j];
        }
    }
    return v;
};

/**
 * Returns the mean of all elements of the matrix
 * @returns {number}
 */
Matrix.prototype.mean = function mean() {
    return this.sum() / this.size;
};

/**
 * Returns the product of all elements of the matrix
 * @returns {number}
 */
Matrix.prototype.prod = function prod() {
    var prod = 1;
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            prod *= this[i][j];
        }
    }
    return prod;
};

/**
 * Computes the cumulative sum of the matrix elements (in place, row by row)
 * @returns {Matrix} this
 */
Matrix.prototype.cumulativeSum = function cumulativeSum() {
    var sum = 0;
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            sum += this[i][j];
            this[i][j] = sum;
        }
    }
    return this;
};

/**
 * Computes the dot (scalar) product between the matrix and another
 * @param {Matrix} other vector
 * @returns {number}
 */
Matrix.prototype.dot = function dot(other) {
    if (this.size !== other.size)
        throw new MatrixError('vectors do not have the same size');
    var vector1 = this.to1DArray();
    var vector2 = other.to1DArray();
    var dot = 0, l = vector1.length;
    for (var i = 0; i < l; i++) {
        dot += vector1[i] * vector2[i];
    }
    return dot;
};

/**
 * Returns the matrix product between this and other
 * @returns {Matrix}
 */
Matrix.prototype.mmul = function mmul(other) {
    if (this.columns !== other.rows)
        console.warn('Number of columns of left matrix are not equal to number of rows of right matrix.');

    var m = this.rows, n = this.columns, p = other.columns;
    var result = new Matrix(m, p);

    var Bcolj = new Array(n);
    var i, j, k;
    for (j = 0; j < p; j++) {
        for (k = 0; k < n; k++)
            Bcolj[k] = other[k][j];

        for (i = 0; i < m; i++) {
            var Arowi = this[i];

            var s = 0;
            for (k = 0; k < n; k++)
                s += Arowi[k] * Bcolj[k];

            result[i][j] = s;
        }
    }
    return result;
};

/**
 * Sorts the rows (in place)
 * @param {function} compareFunction - usual Array.prototype.sort comparison function
 * @returns {Matrix} this
 */
Matrix.prototype.sortRows = function sortRows(compareFunction) {
    for (var i = 0, ii = this.rows; i < ii; i++) {
        this[i].sort(compareFunction);
    }
    return this;
};

/**
 * Sorts the columns (in place)
 * @param {function} compareFunction - usual Array.prototype.sort comparison function
 * @returns {Matrix} this
 */
Matrix.prototype.sortColumns = function sortColumns(compareFunction) {
    for (var i = 0, ii = this.columns; i < ii; i++) {
        this.setColumn(i, this.getColumn(i).sort(compareFunction));
    }
    return this;
};

/**
 * Transposes the matrix and returns a new one containing the result
 * @returns {Matrix}
 */
Matrix.prototype.transpose = function transpose() {
    var result = new Matrix(this.columns, this.rows);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            result[j][i] = this[i][j];
        }
    }
    return result;
};

/**
 * Returns a subset of the matrix
 * @param {number} startRow - First row index
 * @param {number} endRow - Last row index
 * @param {number} startColumn - First column index
 * @param {number} endColumn - Last column index
 * @returns {Matrix}
 */
Matrix.prototype.subMatrix = function subMatrix(startRow, endRow, startColumn, endColumn) {
    if ((startRow > endRow) || (startColumn > endColumn) || (startRow < 0) || (startRow >= this.rows) || (endRow < 0) || (endRow >= this.rows) || (startColumn < 0) || (startColumn >= this.columns) || (endColumn < 0) || (endColumn >= this.columns))
        throw new MatrixError('Argument out of range');
    var newMatrix = new Matrix(endRow - startRow + 1, endColumn - startColumn + 1);
    for (var i = startRow; i <= endRow; i++) {
        for (var j = startColumn; j <= endColumn; j++) {
            newMatrix[i - startRow][j - startColumn] = this[i][j];
        }
    }
    return newMatrix;
};

/**
 * Returns a subset of the matrix based on an array of row indices
 * @param {Array} indices - Array containing the row indices
 * @param {number} [startColumn = 0] - First column index
 * @param {number} [endColumn = this.columns-1] - Last column index
 * @returns {Matrix}
 */
Matrix.prototype.subMatrixRow = function subMatrixRow(indices, startColumn, endColumn) {
    if (typeof startColumn === 'undefined') {
        startColumn = 0;
        endColumn = this.columns - 1;
    } else if (typeof endColumn === 'undefined') {
        endColumn = this.columns - 1;
    }
    if ((startColumn > endColumn) || (startColumn < 0) || (startColumn >= this.columns) || (endColumn < 0) || (endColumn >= this.columns))
        throw new MatrixError('Argument out of range.');
    var l = indices.length, rows = this.rows,
        X = new Matrix(l, endColumn - startColumn + 1);
    for (var i = 0; i < l; i++) {
        for (var j = startColumn; j <= endColumn; j++) {
            if ((indices[i] < 0) || (indices[i] >= rows))
                throw new MatrixError('Argument out of range.');
            X[i][j - startColumn] = this[indices[i]][j];
        }
    }
    return X;
};

/**
 * Returns a subset of the matrix based on an array of column indices
 * @param {Array} indices - Array containing the column indices
 * @param {number} [startRow = 0] - First row index
 * @param {number} [endRow = this.rows-1] - Last row index
 * @returns {Matrix}
 */
Matrix.prototype.subMatrixColumn = function subMatrixColumn(indices, startRow, endRow) {
    if (typeof startRow === 'undefined') {
        startRow = 0;
        endRow = this.rows - 1;
    } else if (typeof endRow === 'undefined') {
        endRow = this.rows - 1;
    }
    if ((startRow > endRow) || (startRow < 0) || (startRow >= this.rows) || (endRow < 0) || (endRow >= this.rows))
        throw new MatrixError('Argument out of range.');
    var l = indices.length, columns = this.columns,
        X = new Matrix(endRow - startRow + 1, l);
    for (var i = 0; i < l; i++) {
        for (var j = startRow; j <= endRow; j++) {
            if ((indices[i] < 0) || (indices[i] >= columns))
                throw new MatrixError('Argument out of range.');
            X[j - startRow][i] = this[j][indices[i]];
        }
    }
    return X;
};

/**
 * Returns the trace of the matrix (sum of the diagonal elements)
 * @returns {number}
 */
Matrix.prototype.trace = function trace() {
    if (!this.isSquare())
        throw new MatrixError('The matrix is not square');
    var trace = 0, i = 0, l = this.rows;
    for (; i < l; i++) {
        trace += this[i][i];
    }
    return trace;
};

/**
 * Sets each element of the matrix to its absolute value
 * @returns {Matrix} this
 */
Matrix.prototype.abs = function abs() {
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] = Math.abs(this[i][j]);
        }
    }
};

Matrix.MatrixError = MatrixError;

module.exports = Matrix;
},{}]},{},[1])(1)
});